// Helpers written as lodash extensions

_.isDev = window.location.href.indexOf('http://activitymessenger.localhost') === 0

_.csrf = document.querySelector('meta[name=csrf-token]').content

_.NO_CLIENT = {
  email: 'noclient@activitymessenger.com',
  name: trans('no_client_name'),
}

_.isNumeric = function(v) {
  return v !== null &&
    !(typeof v == 'string' && !v.trim())
    isFinite(v)
}

_.isObjectEmpty = function(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

_.isPlainObject = function(obj) {
  return _.isObject(obj) && !Array.isArray(obj);
}

_.isObjectKeysEmpty = function(obj) {
  return obj.constructor === Object && Object.values(obj).every(value => {
    if (value === null || value === undefined || value === "") {
        return true; // Treat null, undefined, or empty string as empty
    }
    if (typeof value === "object") {
        // Check if arrays or objects are empty
        return Object.keys(value).length === 0;
    }
    return false; // Non-empty property
  });
}

_.isHumanEmpty = function(value) {
  if (!value || _.isEmpty(value) || typeof value == 'string' && !value.trim()) return true
  if (value && Array.isArray(value) && value.length == 1 && value.includes('none')) return true
  if (typeof value != 'string') return false
  return [
    'aucun',
    'aucune',
    'none',
    'no',
    'non',
    'na',
    'n/a',
  ].indexOf(value.toLowerCase().trim().replace(/,\s*$/, '')) >= 0
}

// Extend moment to output a 6-digit ISO standard date string
// like we expect in PHP. Whereas moment only returns 3.
_.toISOString6 = function(mom) {
  return mom.toISOString().replace('Z', '000Z')
}

_.humanFileSize = function(a,b,c,d,e){
  return (b=Math,c=b.log,d=1e3,e=c(a)/c(d)|0,a/b.pow(d,e)).toFixed(2)+' '+(e?'kMGTPEZY'[--e]+'B':'Bytes')
}

_.url = function(path) {
  let url = _.isDev ?
    'http://activitymessenger.localhost' :
    'https://activitymessenger.com'
  if (path) {
    if (path[0] != '/') url += '/'
    url += path
  }
  return url
}

_.fillObjFromData = function (object, dataObject) {
    let returnObject = _.cloneDeep(object);

    Object.keys(dataObject || {}).forEach(function(key) {
        if(returnObject.hasOwnProperty(key)){
            if (typeof dataObject[key] === "object") {
                if (returnObject[key] === undefined) {
                    returnObject[key] = {};
                }
                returnObject[key] = _.fillObjFromData(returnObject[key], dataObject[key]);
            } else {
                returnObject[key] = dataObject[key];
            }
        }
    });

    return returnObject;
}

_.cartUrl = function(organization, ucid) {
  let url = _.isDev ?
    'http://activitymessenger.localhost' :
    'https://activitymessenger.com'
  return url + `/org/${organization.id}/cart/take/${ucid}`
}

_.sendInvoiceUrl = function(organization, invoice) {
  let url = invoice.invoice_no ?
    `/organization/${organization.id}/sendout/create?invoice_no=${invoice.invoice_no}&type=email&subject=${encodeURIComponent(trans('invoice') + ' ' + invoice.invoice_no)}` :
    `/organization/${organization.id}/sendout/create?ucid=${invoice.ucid}&type=email&subject=${encodeURIComponent(trans('shopping_cart'))}`
  url += '&initial_message_sample_id=shopping_cart'
  if (!invoice.is_no_client && invoice.recipient)
    url += `&email=${encodeURIComponent(invoice.recipient.email)}&mobile=${invoice.recipient.mobile||''}&name=${encodeURIComponent(invoice.recipient.name)}`
  return url
}

_.toggleFullScreen = function(component, value) {
  component.$root.$emit('bv::hide::tooltip')
  if (value) {
    document.querySelector('.app-content').className = 'container app-content'
    document.querySelectorAll('.d-fullscreen-none').forEach(function(el) {
      el.className = el.className.replace(' d-none', '')
    })
    return false
  } else {
    document.querySelector('.app-content').className = 'container-fluid app-content'
    document.querySelectorAll('.d-fullscreen-none').forEach(function(el) {
      el.className = el.className + ' d-none'
    })
    return true
  }
}

_.toggleCookie = function(name) {
  let value = document.cookie.split('; ').find(row => row.startsWith(name+'='))
  if (value) value = value.split('=')[1]
  if (value) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  } else {
    document.cookie = name +'=true; Path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;';
  }
}

_.diffObjects = function(object, base) {
  function changes(object, base) {
      return _.transform(object, function(result, value, key) {
          if (!_.isEqual(value, base[key])) {
              result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value
          }
      })
  }
  return changes(object, base);
}

_.matchTerms = function(search, text, use_or) {
  if (use_or === true) {
    let needles = _.compact(((search||'')+'').trim().toLowerCase().split(/\s+/))
    let haystack = (text+'').trim().toLowerCase()
    for (let i = 0; i < needles.length; i++)
      if (haystack.indexOf(needles[i]) >= 0) return true
    return false
  }
  let needle = ((search||'')+'').trim().toLowerCase().replace(/\s\s+/g, ' ')
  let haystack = ((text||'')+'').trim().toLowerCase().replace(/\s\s+/g, ' ')
  return haystack.indexOf(needle) >= 0
}
_.matchTermsOrEmptySearch = function(search, text, use_or) {
  return !((search||'')+'').trim().toLowerCase() || _.matchTerms(search, text, use_or)
}

_.linkType = function(url, old_type, organization_id) {
  if (!url) return null
  if (url.indexOf('https://activitymessenger.com/p/') === 0 ||
      url.indexOf('http://activitymessenger.localhost/p/') === 0)
  return 'form'
  if (_.validateEmail(url))
    return 'email'
  if (_.validatePhone(url))
    return 'tel'
  if (url.indexOf(`${organization_id}/calendar/invoice/`) !== -1)
    return 'i_calendar'
  if (url.indexOf(`${window.location.origin}/pay/`) === 0)
    return 'pay_invoice'
  if (url.indexOf('https://activitymessenger.com/document') === 0 ||
      url.indexOf('http://activitymessenger.localhost/document') === 0 ||
      url.indexOf('https://am.lol/f/') === 0 ||
      url.indexOf('https://am.lol/g/') === 0)
    return 'document'
  if (url.indexOf(`https://activitymessenger.com/org/${organization_id}`) === 0 ||
      url.indexOf(`http://activitymessenger.localhost/org/${organization_id}`) === 0 ||
      url.indexOf('https://am.lol/s/') === 0 ||
      url.indexOf('https://am.lol/z/') === 0)
    return 'page'
  if (url.indexOf('https://activitymessenger.com/video/') === 0 ||
      url.indexOf('http://activitymessenger.localhost/video/') === 0 ||
      url.indexOf('https://am.lol/v/') === 0 ||
      url.indexOf('https://am.lol/w/') === 0)
    return 'video'
  return old_type || null
}

_.ensureUrl = function(url) {
  if (!url) return url
  url = url.trim()
  if (url.indexOf('http://') === 0) return url
  if (url.indexOf('https://') === 0) return url
  if (url.indexOf('mailto:') === 0) return url
  if (url.indexOf('tel:') === 0) return url
  if (_.validateEmail(url)) return 'mailto:' + url
  if (_.validatePhone(url)) return 'tel:' + url
  return url
}

// moment().weekday(i) sucks - in English 0 = Sunday
// while in French 0 = Monday. Go figure.
// This helper side steps this issue. SUNDAY IS ALWAYS 0!!!
_.weekdayLabel = function(i, format) {
  let method = 'weekdays' // dddd
  if (format == 'ddd') method += 'Short'
  else if (format == 'dd') method += 'Min'
  const weekdays = moment[method]()
  return weekdays[i % 7]
}

_.firstDayOptions = [] // 0 = Sunday
for (let i = 0 ; i < 7; i++) _.firstDayOptions.push({
  text: _.weekdayLabel(i, 'ddd'),
  value: i,
})
_.weekdayOptions = [];
for (let i = 0 ; i < 7; i++) _.weekdayOptions.push({
  text: _.weekdayLabel(i, 'dddd'),
  value: i,
})

_.isoWeekdayToEnglish = function(i) {
  if (!i || i < 1 || i > 7 || !_.isNumeric(i)) return null
  return [
    'Monday', // 1
    'Tuesday', // 2
    'Wednesday', // 3
    'Thursday', // 4
    'Friday', // 5
    'Saturday', // 6
    'Sunday', // 7
  ][i-1]
}

_.formatZoomMeetingId = function(id) {
  if (!id) return id
  const str = (id + '').replace(/\s/g, '')
  if (str.length == 9) return `${str.substr(0,3)} ${str.substr(3,3)} ${str.substr(6,3)}`
  if (str.length == 10) return `${str.substr(0,3)} ${str.substr(3,3)} ${str.substr(6,4)}`
  if (str.length == 11) return `${str.substr(0,3)} ${str.substr(3,4)} ${str.substr(7,4)}`
  if (str.length == 12) return `${str.substr(0,4)} ${str.substr(4,4)} ${str.substr(8,4)}`
  return str
}

_.calculateTaxes = function(price, taxes) {
  if (!taxes || taxes.length == 0) return null
  price = parseFloat(price)
  if (isNaN(price)) return null

  let price_before_tax = price
  let inclusive_taxes = 0
  let inclusive_rate = _.reduce(taxes, (sum, tax) => {
    if (tax.inclusive) sum += tax.percentage/100
    return sum
  }, 0)
  if (inclusive_rate > 0) {
    inclusive_taxes = _.round(price - price / (1 + inclusive_rate), 2)
    price_before_tax = _.round(price - inclusive_taxes, 2)
  }
  let exclusive_taxes = _.reduce(taxes, (sum, tax) => {
    if (!tax.inclusive) {
      let rate = tax.percentage/100
      let tax_amount = _.round(price_before_tax * (1 + rate) - price_before_tax, 2)
      sum += tax_amount
    }
    return sum
  }, 0)

  return {
    display: _.round(price, 2),
    afterTax: _.round(price_before_tax + inclusive_taxes + exclusive_taxes, 2),
    beforeTax: _.round(price_before_tax, 2),
    exclusiveTaxes: _.round(exclusive_taxes, 2),
    inclusiveTaxes: _.round(inclusive_taxes, 2),
    tax: _.round(inclusive_taxes + exclusive_taxes, 2),
  }
}

_.escapeRegExp = function(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
_.mapAmiliaChildren = function(map, participants) {
  participants.forEach(o => {
    if (!o.is_child) return true
    if (!map[o.account_owner_id]) {
      map[o.account_owner_id] = {}
    }
    if (!map[o.account_owner_id][o.id]) {
      map[o.account_owner_id][o.id] = _.pick(o, ['name', 'date_of_birth', 'gender', 'age', 'registrations'])
      map[o.account_owner_id][o.id].amilia_id = o.id
    }
    let mapped = map[o.account_owner_id][o.id]
    if (!mapped.date_of_birth && o.date_of_birth) {
      mapped.date_of_birth = o.date_of_birth
    }
    if (!mapped.gender && o.gender) {
      mapped.gender = o.gender
    }
  })
}

_.mapAmiliaActivities = function(map, activities) {
  activities.forEach(a => {
    if (!map[a.id]) map[a.id] = _.pick(a, [
      'id', 'name',
      'subcategory_id', 'subcategory_name',
      'category_id', 'category_name',
      'program_id', 'program_name',
      'team_name', 'team_color',
      'schedule_summary',
      'responsible_name',
      'location_name',
    ])
    if (a.occurrences && a.occurrences.length) {
      map[a.id].start = a.occurrences[0].start
      map[a.id].end = a.occurrences[0].end
      if (!!a.occurrences[0].location_name)
        map[a.id].location_name = a.occurrences[0].location_name
      map[a.id].staff = a.occurrences[0].staff || null
      map[a.id].occurrences = a.occurrences
    }
    if (!map[a.id].team_name && a.team_name) map[a.id].team_name = a.team_name
    if (!map[a.id].team_color && a.team_color) map[a.id].team_color = a.team_color
  })
}

// Placeholder functions. Keep in sync with equivalent PHP code in /app/Helpers/Global/GeneralHelper.php

_.splitFullName = function(name) {
  let full_name = (name || '').trim()
  let first_name = ''
  let last_name = ''
  if (name && name.indexOf(',') >= 0) {
    // iClassPro has "Drapeau, Martin" - assume this is it
    const parts = full_name.split(',')
    last_name = parts.shift().trim()
    first_name = parts.join(' ').trim()
    full_name = first_name + ' ' + last_name
  }
  else if (name) {
    const parts = full_name.split(/\s/)
    first_name = parts.shift().trim()
    last_name = parts.join(' ').trim()
    full_name = first_name + ' ' + last_name
  }
  return [full_name, first_name, last_name]
}

_.fullName = function(person) {
  if (person.name) return person.name
  return _.compact([person.first_name, person.last_name]).join(' ')
}

_.getUrlPlaceholders = function() {
  if (window.lang == 'fr') {
    return {
      'Personne' : [{label: 'Prénom', value: 'prenom', url: 'first_name'}, {label: 'Nom', value: 'nom de famille', url: 'last_name'}, {label: 'Nom du responsable de compte', value: 'nom', url: 'name'}, {label: 'Courriel', value: 'courriel', url: 'email'}],
      'Cours (activité)': [{label: 'Date/heure de début', value: 'iso date', url: 'date'}],
    }
  } else {
    return {
      'Person' : [{label: 'Name', value: 'first name', url: 'first_name'}, {label: 'Last name', value: 'last name', url: 'last_name'}, {label: 'Account owner name', value: 'name', url: 'name'}, {label: 'Email', value: 'email', url: 'email'}],
      'Class (Activity)': [{label: 'Start date/time', value: 'iso date', url: 'date'}],
    }
  }
}

_.getGroupedPlaceholders = function() {
  if (window.lang == 'fr') {
    return {
      'Personne' : ['Nom', 'Prénom', 'Nom de famille', 'Nom du responsable de compte', 'Prénom du responsable de compte', 'Nom de famille du responsable de compte', 'Courriel du responsable de compte', 'Adresse du responsable de compte', 'Nom du participant', 'Prénom du participant', 'Nom de famille du participant', 'Date de naissance du participant', 'Prénom(s) de(s) enfant(s)', 'Nom de l\'autre parent', 'Prénom de l\'autre parent', 'Nom de famille de l\'autre parent', 'Compagnie'],
      'Formulaire': ['Formulaire',],
      'Cours (activité)': ['Toutes les inscriptions', 'Inscriptions', 'Cours', 'Description du cours', 'Activité', 'Sous-catégorie', 'Catégorie', 'Programmation', 'Groupe', 'Responsable', 'Nom(s) du personnel', 'Prénom(s) du personnel', 'Lieu', 'Date/heure de début', 'Date de début', 'Heure de début', 'Heure de fin', 'Jour de la semaine du début', 'Jour de la semaine de la fin',  'Date/heure du prochain', 'Date du prochain', 'Heure du prochain', /*'Date/heure de fin', */'Date de fin', 'Les dates', 'Service de garde', 'Mot de passe', 'Ami', 'Sur mesure', 'Codes barre des participants', 'Lien pour le cours virtuel', 'Informations supplémentaires', 'Billet'],
      'Équipe': ['Équipe', 'Gestionnaire de l\'équipe', 'Joueurs de l\'équipe', 'Joueurs de l\'équipe avec leurs contributions', 'Solde de l\'équipe', 'Les dates', 'Date/heure de début', 'Lieu',],
      'Abonnement': ['Abonnement', "Expiration de l'abonnement", 'Laissez-passer', 'Expiration du laissez-passer', 'Nombre de Laissez-passers',],
      'Zoom': ['URL de la réunion Zoom', 'ID de la réunion Zoom'/*, 'Mot de passe de la réunion Zoom'*/,],
      'Autre': ['Réservations', 'Code de porte par date de réservation', 'Codes coupons', 'Solde de la facture', 'Prochain montant dû', 'URL pour payer la facture', "Date d'aujourdhui", 'URL du contract'],
      'Organisation': _.getOrganizationPlaceholders(),
    }
  } else {
    return {
      'Person' : ['Name', 'First name', 'Last name', 'Account owner name', 'Account owner first name', 'Account owner last name', 'Account owner email', 'Account owner address', 'Participant name', 'Participant first name', 'Participant last name', 'Participant date of birth', 'Child/children first name(s)', 'Other parent name', 'Other parent first name', 'Other parent last name', 'Company'],
      'Form' : ['Form',],
      'Class (Activity)': ['All registrations', 'Registrations', 'Class', 'Class description', 'Activity', 'Subcategory', 'Category', 'Program', 'Group', 'Responsible', 'Location', 'Staff name(s)', 'Staff first name(s)', 'Start date/time', 'Start date', 'Start time', 'End time', 'Start day of the week', 'End day of the week', 'Next date/time', 'Next date', 'Next time', /*'End date/time', */'End date', 'All dates', 'Daycare', 'Password', 'Friend', 'Custom', 'Participants barcodes', 'Virtual class link', 'Additional information', 'Ticket'],
      'Team': ['Team', 'Team manager', 'Team players', 'Team players with contributions', 'Team balance', 'All dates', 'Start date/time', 'Location',],
      'Membership': ['Membership', 'Membership expiration', 'Multipass', 'Multipass expiration', 'Multipass tokens',],
      'Zoom': ['Zoom meeting URL', 'Zoom meeting ID'/*, 'Zoom meeting password'*/,],
      'Other': ['Bookings', 'Booking door code by date', 'Coupon codes', 'Invoice balance', 'Next amount due', 'URL to pay the invoice', "Today's Date", 'Contract URL'],
      'Organization': _.getOrganizationPlaceholders(),
    }
  }
}

_.getGroupedPlaceholdersForFormAnswers = function() {
  let placeholders = _.getGroupedPlaceholders()
  if (window.lang == 'fr') {
    return {
      Personne: placeholders.Personne,
      Formulaire: placeholders.Formulaire,
      Organisation: placeholders.Organisation,
    }
  } else {
    return {
      Person: placeholders.Personne,
      Form: placeholders.Formulaire,
      Organization: placeholders.Organization,
    }
  }
}

_.getPlaceholders = function() {
  const groupedPlaceholders = _.getGroupedPlaceholders()
  return _.reduce(_.keys(groupedPlaceholders), (result, group) => {
    return _.union(result, groupedPlaceholders[group])
  }, [])
}

_.cleanPlaceholder = function(name) {
  if (!name) return name
  return _.removeDiacritics((name||'')).trim().replace(/^{/g, '').replace(/}$/g, '').replace(/\s\s+/g, ' ').toLowerCase()
}

_.getClassEventPlaceholders = function() {
  return window.lang == 'fr' ?
    ['Cours', /*'Nom(s) du personnel', 'Prénom(s) du personnel', 'Lieu',*/ 'Date/heure de début', 'Date de début', 'Heure de début', 'Heure de fin'] :
    ['Class', /*'Staff name(s)', 'Staff first name(s)', 'Location',*/ 'Start date/time', 'Start date', 'Start time', 'End time']
}

_.createPlaceholdersForClassEvent = function(cls, event) {
  cls || (cls = {})
  event || (event = {})
  return {
    'class': cls.name || '',
    'staff name(s)': '',
    'staff first name(s)': '',
    'location': !!event && !!event.location ? event.location.name : '',
    'start date/time': !!event && !!event.start ? moment(event.start).format('LLL') : '',
    'start date': !!event && !!event.start ? moment(event.start).format('LL') : '',
    'start time': !!event && !!event.start ? moment(event.start).format('LT') : '',
    'end time': !!event && !!event.end ? moment(event.end).format('LT') : '',

    'cours': cls.name || '',
    'nom(s) du personnel': '',
    'prenom(s) du personnel': '',
    'lieu': !!event && !!event.location ? event.location.name : '',
    'date/heure de debut': !!event && !!event.start ? moment(event.start).format('LLL') : '',
    'date de debut': !!event && !!event.start ? moment(event.start).format('LL') : '',
    'heure de debut': !!event && !!event.start ? moment(event.start).format('LT') : '',
    'heure de fin': !!event && !!event.end ? moment(event.end).format('LT') : '',
  }
}

_.getOrganizationPlaceholders = function() {
  return window.lang == 'fr' ?
    ["Nom de l'organisation", "Adresse de l'organisation", "Téléphone de l'organisation", "URL de l'organisation", "Courriel de l'organisation", 'Année', 'URL du compte client'] :
    ['Organization name', 'Organization address', 'Organization telephone', 'Organization URL', 'Organization email', 'Year', 'Client account URL']
}

_.createPlaceholdersForOrganization = function(organization) {
  organization || (organization = {})
  return {
    'child/children first name(s)': 'your child',
    'organization name': organization.name || '',
    'organization address': organization.address || '',
    'organization telephone': organization.phone || '',
    'organization url': organization.url || '',
    'organization email': organization.email || '',
    'year': moment().format('YYYY'),
    'url du compte client': _.url(`/org/${organization.id}/client`),

    'prenom(s) de(s) enfant(s)': 'votre enfant',
    "nom de l'organisation": organization.name || '',
    "adresse de l'organisation": organization.address || '',
    "telephone de l'organisation": organization.phone || '',
    "url de l'organisation": organization.url || '',
    "courriel de l'organisation": organization.email || '',
    'annee': moment().format('YYYY'),
    'client account url': _.url(`/org/${organization.id}/client`),
  }
}

_.replacePlaceholders = function(text, placeholders) {
  if (!placeholders || !text) return text

  const matches = text.match(/{(.*?)}/g)
  if (!matches) return text

  for (var i = 0; i < matches.length; i++) {
    const placeholder = matches[i]
    const k = _.cleanPlaceholder(placeholder)
    let v = placeholders[k]
    const search = `<span class="placeholder">${placeholder}</span>`
    if (!v) {
      text = text.replace('&nbsp;'+search, '')
        .replace('&nbsp;</span>'+search, '</span>')
        .replace('&nbsp;</strong>'+search, '</strong>')
        .replace('&nbsp;</em>'+search, '</em>')
        .replace('&nbsp;</i>'+search, '</i>')
        .replace('&nbsp;</u>'+search, '</u>')
        .replace('&nbsp;</strong></span>'+search, '</strong></span>')
        .replace('&nbsp;</em></span>'+search, '</em></span>')
        .replace('&nbsp;</i></span>'+search, '</i></span>')
        .replace('&nbsp;</u></span>'+search, '</u></span>')
        .replace(search, '')
      if (k.indexOf('zoom') >= 0 && k.indexOf('password') >= 0) {
        text = text.replace(`<p style="margin-bottom:0;">Meeting password</p><h4 style="margin-top:0;">${placeholder}</h4>`, '')
      }
      else if (k.indexOf('zoom') >= 0 && k.indexOf('mot de passe') >= 0) {
        text = text.replace(`<p style="margin-bottom:0;">Mot de passe</p><h4 style="margin-top:0;">${placeholder}</h4>`, '')
      }
      else if (k.indexOf('zoom') >= 0) {
        text = text.replace(placeholder, '')
      }
    } else {
      if (k.indexOf('zoom') >= 0 && k.indexOf('url') >= 0 ||
        k.indexOf('organi') >= 0 && k.indexOf('url') >= 0 ||
        k.indexOf('organi') >= 0 && (k.indexOf('email') >= 0 || k.indexOf('courriel') >= 0)) {
        let vv = v
        if (k.indexOf('organi') >= 0 && k.indexOf('url') >= 0) {
          vv = v.replace('http://', '').replace('https://', '').replace(/\/$/, '')
        }
        if (k.indexOf('email') >= 0 || k.indexOf('courriel') >= 0) {
          v = 'mailto:' + v
        }
        text = text.replace(`<a href="${placeholder}">${placeholder}</a>`, `<a href="${v}">${vv}</a>`)
        text = text.replace(placeholder, `<a href="${v}">${vv}</a>`)
      }
      else if (k.indexOf('zoom') >= 0) {
        text = text.replace(placeholder, v)
      }
      else if (k.match(/(child)|(enfant)/)) {
        const many = v.length > 0 && v.match(/(,\s)|(\set\s)|(\sand\s)/)
        const prefixes = many ?
          {
            'has': 'have', 'is': 'are', 'was': 'were',
            'votre': 'vos', 'tes': 'ton',
          } :
          {
            'have': 'has', 'are': 'is', 'were': 'was',
            'vos': 'votre', 'ton': 'tes',
          }
        _.each(prefixes, (replacement, seed) => {
          text = text.replace(seed+'&nbsp;'+search, replacement+'&nbsp;'+search)
          text = text.replace(_.capitalize(seed)+'&nbsp;'+search, _.capitalize(replacement)+'&nbsp;'+search)
        })
        const postfixes = many ?
          {
            'has': 'have', 'is': 'are', 'was': 'were',
            'a': 'ont', 'est': 'sont', 'était': 'étaient',
          } :
          {
            'have': 'has', 'are': 'is', 'were': 'was',
            'ont': 'a', 'sont': 'est', 'étaient': 'était',
          }
        _.each(postfixes, (replacement, seed) => {
          text = text.replace(search+'&nbsp;'+seed+' ', search+'&nbsp;'+replacement+' ')
        })
      }
      text = text.replace(search, v)
    }
  }

  return text
}

_.getSpamWarning = function(text) {
  if (!text) return null

  let words = _.map(text.split(' '), word => {
    return word.trim()
  })

  let uppercase_word = _.reduce(words, (found, word) => {
    if (!found &&
      word.length > 3 &&
      word.toUpperCase().replace(/[^A-Z]+/g, '_') == word) {
      found = word
    }
    return found
  }, null)
  if (!!uppercase_word) {
    return trans('subject_has_all_caps')
  }

  if (text.indexOf('$') >= 0) {
    return trans('subject_has_spam_words').replace(':words', '$')
  }

  let spam_words = lang == 'fr' ?
    ['gratuit', 'offre', 'offres', 'rappel', 'urgent'] :
    ['free', 'offer', 'offers', 'reminder', 'urgent']
  let warning_words = _.reduce(words, (warning_words, word) => {
    let check = word.toLowerCase()
    if (spam_words.indexOf(check) >= 0) warning_words.push(word)
    return warning_words
  }, [])
  if (warning_words.length > 0) {
    return trans('subject_has_spam_words').replace(':words', warning_words.join(', '))
  }

  return null
}

_.ckeditorHtmlToText = function(html) {
  let str = (html||'').replace('</p><p>', '</p>&nbsp;<p>')
  return _.stripHtml(str)
}

_.urlify = function(text, target) {
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function(url) {
    return `<a href="${url}"${!!target ? ` target="${target}"` : ''}>${url.replace('http://', '').replace('https://', '')}</a>`
  })
}

_.toastError = function(component, error) {
  component.$bvToast.toast(error || 'Unknown error', {
    title: trans('error'),
    variant: 'danger',
    solid: true,
  })
}
_.toastSuccess = function(component, message) {
  component.$bvToast.toast(message, {
    title: trans('success'),
    variant: 'success',
    solid: true,
  })
}

_.errorFromAjax = function(error) {
  let result = null
  if (error && error.response && error.response.data) {
    result = error.response.data.errors ?
      _.values(error.response.data.errors).join(' ') :
      (error.response.data.message ? error.response.data.message : error.response.data)
  } else {
    result = error
  }
  if (_.isEmpty(result)) result = trans('unexpected_error')
  return result;
}

_.getScheduledStatus = function(scheduled_at, when) {
  if (!scheduled_at) return null
  scheduled_at = moment(scheduled_at)
  if (when) {
    when = moment(when)
  } else {
    when = moment()
    when.second(0)
    when.minute(when.minute() - (when.minute() % 5))
  }
  if (scheduled_at.isBetween(when, when.clone().add(5, 'm'), 'm', '[)')) return 'sending'
  if (scheduled_at.isSameOrAfter(when.clone().add(5, 'm'), 'm')) return 'pending'
  if (scheduled_at.isBefore(when, 'm')) return 'passed'
  return null
}

_.printHoursFromMinutes = function(minutes) {
  if (!minutes) return 0
  let hours = Math.floor(minutes / 60)
  if (!hours) return `${minutes}m`
  let result = `${hours}h`
  minutes = minutes % 60
  if (minutes > 0) result += ` ${minutes}m`
  return result
}

_.eventStatusVariant = function(status) {
  switch(status) {
    case 'new':
      return 'primary'
    case 'scheduled':
      return 'secondary'
    case 'invoiced':
      return 'danger'
    case 'sent':
      return 'info';
    case 'paid':
      return 'success'
  }
  return 'light'
}

_.stripHtml = function(html) {
   var tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
}

_.isEmpty = function(n) {
    return !(!!n ? typeof n === 'object' ? Array.isArray(n) ? !!n.length : !!Object.keys(n).length : true : false);
}

_.defaultRanges = function(inFutur, limitMonth) {
  let defaultRanges = {}
  if(!inFutur) {
    defaultRanges[trans('today')] = [moment().toDate(), moment().toDate()]
    defaultRanges[trans('yesterday')] = [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()]
    defaultRanges[trans('this_week')] = [moment().startOf('week').toDate(), moment().endOf('week').toDate()]
    defaultRanges[trans('last_week')] = [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()]
    defaultRanges[trans('this_month')] = [moment().startOf('month').toDate(), moment().endOf('month').toDate()]
    defaultRanges[trans('last_month')] = [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]
    defaultRanges[trans('last_3_months')] = [moment().subtract(3, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]
    if (!limitMonth) {
      defaultRanges[trans('this_year')] = [moment().startOf('year').toDate(), moment().endOf('year').toDate()]
      defaultRanges[trans('last_year')] = [moment().startOf('year').subtract(1, 'years').toDate(), moment().endOf('year').subtract(1, 'years').toDate()]
    }
  } else {
    defaultRanges[trans('in_one_month')] = [moment().toDate(), moment().add(1, 'month').toDate()]
    defaultRanges[trans('in_three_months')] = [moment().toDate(), moment().add(3, 'month').toDate()]
    defaultRanges[trans('in_six_months')] = [moment().toDate(), moment().add(6, 'month').toDate()]
    defaultRanges[trans('in_one_year')] = [moment().toDate(), moment().add(12, 'month').toDate()]
  }
  return defaultRanges
}

_.dateRangeStr = function(start, end, noYear = false, endExclusive = false) {
    if (!start) return ''
    let s = moment(start)
    if (!end || start == end) return s.format('D MMM' + (!noYear ? ' Y' : ''))
    let e = moment(end)
    if (endExclusive) e.add(-1, 'days')
    let str = ''
    str = s.format('D')
    if (s.month() == e.month() && s.year() == e.year()) {
      str += ' -'
    } else {
      str += ` ${s.format('MMM')}`
      if (!noYear && s.year() != e.year()) str += ` ${s.format('Y')}`
      str += ' -'
    }
    str += ` ${e.format('D MMM' + (!noYear ? ' Y' : ''))}`
    return str
}

_.timeRangeStr = function(start, end, noYear = false) {
  if (!start) return ''
  let s = moment(start)
  if (!end) {
    let str = s.format('D MMM')
    if (!noYear) str += `, ${s.format('Y')}`
    str += ` ${s.format('LT')}`
    return str
  }
  let e = moment(end)
  let str = s.format('D MMM')
  if (!noYear) str += `, ${s.format('Y')}`
  if (s.isSame(e, 'day')) {
    str += ` ${s.format('LT')} - ${e.format('LT')}`
  } else {
    str += ` ${s.format('LT')} - ${e.format('D MMM LT')}`
  }
  return str
}

_.formatDateTime = function(d) {
  let m = moment(d)
  return m.format(m.isSame(moment(m).startOf('day')) ? 'ddd LL' : 'ddd LLL')
}

_.formatRecurringDateTime = function(d) {
  let m = moment(d)
  let prefix = m.format('dddd')
  if (window.lang == 'fr') prefix = 'Les ' + prefix
  prefix += 's, ' + trans('starting_on').toLowerCase() + ' '
  return prefix + m.format('LLL')
}

_.buildMaxTime = function(min_time, max_time) {
  min_time || (min_time = '00:00:00')
  max_time = max_time == '00:00:00' || !max_time ? '24:00:00' : max_time
  let max_m = moment(max_time, 'HH:mm:ss')
  let min_m = moment(min_time, 'HH:mm:ss')
  if (max_m.isAfter(min_m)) return max_time
  max_m.add(1, 'day')
  let hours = max_m.diff(min_m.startOf('day'), 'hours')
  let parts = max_time.split(':')
  parts[0] = hours
  return parts.join(':')
}

_.pickColor = function(index) {
  const colors = [
    'rgb(216, 27, 93, 0.7)',
    'rgb(5, 130, 194, 0.7)',
    'rgb(40, 167, 69, 0.7)',
    'rgb(138, 43, 226, 0.7)',
    'rgb(139, 69, 19, 0.7)',
  ]
  return colors[index % colors.length]
}

_.rgb2hex = function(rgb) {
  let rgbarr = rgb.split(',')
  return "#" + (1 << 24 | rgbarr[0] << 16 | rgbarr[1] << 8 | rgbarr[2]).toString(16).slice(1)
}

_.hexContrastColor = function(hexColor, muted) {
  let blackColor = "#000000"
  if (!hexColor) return blackColor
  hexColor = hexColor.trim()
  if (hexColor.indexOf('rgb') === 0) hexColor = rgb2hex(hexColor)
  if (hexColor.indexOf('#') !== 0 || hexColor.length != 7) return blackColor

  // hexColor RGB
  let R1 = parseInt('0x'+hexColor.substring(1,3), 16)
  let G1 = parseInt('0x'+hexColor.substring(3,5), 16)
  let B1 = parseInt('0x'+hexColor.substring(5,7), 16)

  // Black RGB
  let R2BlackColor = parseInt('0x'+blackColor.substring(1,3), 16)
  let G2BlackColor = parseInt('0x'+blackColor.substring(3,5), 16)
  let B2BlackColor = parseInt('0x'+blackColor.substring(5,7), 16)

  // Calc contrast ratio
  let L1 = 0.2126 * Math.pow(R1 / 255, 2.2) +
    0.7152 * Math.pow(G1 / 255, 2.2) +
    0.0722 * Math.pow(B1 / 255, 2.2)

  let L2 = 0.2126 * Math.pow(R2BlackColor / 255, 2.2) +
    0.7152 * Math.pow(G2BlackColor / 255, 2.2) +
    0.0722 * Math.pow(B2BlackColor / 255, 2.2)

  let contrastRatio = 0
  if (L1 > L2) {
      contrastRatio = Math.floor((L1 + 0.05) / (L2 + 0.05))
  } else {
      contrastRatio = Math.floor((L2 + 0.05) / (L1 + 0.05))
  }

  // If contrast is more than 5 (changed to 6), return black color
  if (contrastRatio > 6) {
      return muted ? '#2f2f2f' : '#0f0f0f';
  } else {
      // if not, return white color.
      return muted ? '#d0d0d0' : '#f0f0f0';
  }
}

_.numeralFormat = function(showCurrency, decimals) {
  decimals || (decimals = 0)
  let format = '0,0'
  if (decimals >= 0) {
    format += '.'
    for (var i = 0; i < decimals; i++) format += '0'
  }
  if (showCurrency) format += ' $'
  return format
}

_.currency = function(amount, format, lang) {
  if (format == 2) format = _.numeralFormat(false, 2)
  let f = (format || '0,000[.]00')
  let l = (lang || window.lang)
  if (l == 'en') f = '$' + f
  else f += ' $'
  return numeral(amount).format(f)
}

_.percentage = function(num, decimals) {
  if (num === null || num === undefined || !_.isNumeric(num)) return num
  let format = '0%'
  if (decimals > 0) {
    format = '0.'
    for (let i = 0; i < decimals; i++) format += '0'
    format += '%'
  }
  return numeral(num).format(format)
}

_.validateEmail = function(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

_.validatePhone = function(phone) {
  phone = (phone||'') + ''
  let number = _.formatPhone(phone)
  return !isNaN(parseInt(number, 10)) && number.replace(/-/g, '').length == 10
}

_.formatPhone = function(phone, fallback) {
  let number = ((phone||'')+'').replace(/\D/g,'').replace(/^1/, '')
  if (number.length != 10) return (fallback !== undefined ? fallback : phone)
  return number.substr(0, 3) + '-' +
    number.substr(3, 3) + '-' +
    number.substr(6, 4)
}

_.formatPartialPhone = function(phone) {
  let number = ((phone||'')+'').replace(/\D/g,'').replace(/^1/, '')
  return _.compact([number.substr(0, 3), number.substr(3, 3), number.substr(6, 4)]).join('-')
}

_.extractName = function(str) {
  if (!str) return null
  let parts = str.split(/\s+/)
  let nameParts = []
  for (let i = 0; i < parts.length; i++) {
    let part = parts[i].replace(/[<>\[\]\(\)]/g, '')
    if (!_.validateEmail(part) && !_.formatPartialPhone(part))
      nameParts.push(part)
  }
  return nameParts.join(' ') || null
}
_.extractEmail = function(str) {
  if (!str) return null
  let parts = str.split(/\s+/)
  for (let i = 0; i < parts.length; i++) {
    let part = parts[i].replace(/[<>\[\]\(\)]/g, '')
    if (_.validateEmail(part)) return part
  }
  return null
}
_.extractMobile = function(str) {
  if (!str) return null
  let parts = str.split(/\s+/)
  for (let i = 0; i < parts.length; i++) {
    let part = parts[i].replace(/[<>\[\]\(\)]/g, '')
    if (part.indexOf('@') === -1 &&
      _.formatPartialPhone(part)) return part
  }
  return null
}
_.extractRecipients = function(str) {
  let recipients = []
  let parts = str.split(/[,;\t]+/)
  for (let r = 0; r < parts.length; r++) {
    let name = _.extractName(parts[r])
    let email = _.extractEmail(parts[r])
    let mobile = _.extractMobile(parts[r])
    if (name || email || mobile)
      recipients.push({name, email, mobile})
  }
  return recipients
}
_.extractWords = function(str, toLowerCase) {
  if (_.isEmpty(str)) return []
  return (toLowerCase === true ? (str+'').toLowerCase() : (str+'')).split(/[\ \n\,]+/g)
}

_.copyToClipboard = function(str) {
  var $textarea = $('<textarea style="position:absolute;left:-9999px;" readonly></textarea>');
  $('body').append($textarea);
  $textarea.val(str);
  $textarea[0].select();
  document.execCommand('copy');
  $textarea.remove();
}

_.convert = function(data, separator, convertors) {
  separator || (separator = ',');
  if (!_.isObject(data)) throw 'Your JSON must be an array or an object.';
  if (!_.isArray(data)) data = [data];

  var allKeys = [],
      allRows = [];
  for (var i = 0; i < data.length; i++) {
    var o = data[i],
        row = {};
    if (o !== undefined && o !== null && (!_.isObject(o) || _.isArray(o)))
      throw 'Item in array is not an object: ' + JSON.stringify(o);
    var keys = _.keys(o);
    for (var k = 0; k < keys.length; k++) {
      var key = keys[k];
      if (allKeys.indexOf(key) === -1) allKeys.push(key);
      var value = o[key];
      if (convertors && typeof convertors[key] == 'function') {
        row[key] = convertors[key](value);
      }
      else if (value === undefined || value === null) {
        continue;
      }
      else if (_.isString(value)) {
        row[key] = '"' + value.replace(/"/g, '""') + '"';
      }
      else {
        row[key] = JSON.stringify(value);
        if (_.isObject(value) || _.isArray(value))
          row[key] = '"' + row[key].replace(/"/g, '""').replace(/\n/g, '\\n') + '"';
      }
    }
    allRows.push(row);
  }

  var keyValues = [];
  for (var i = 0; i < allKeys.length; i++) {
    keyValues.push('"' + allKeys[i].replace(/"/g, '""') + '"');
  }

  var csv = keyValues.join(separator)+'\n';
  for (var r = 0; r < allRows.length; r++) {
    var row = allRows[r],
        rowArray = [];
    for (var k = 0; k < allKeys.length; k++) {
      var key = allKeys[k];
      rowArray.push(row[key] || '');
    }
    csv += rowArray.join(separator) + '\n';
  }

  return csv;
}

_.pickImportableRecipientColumns = function(r) {
  let result = _.pick(r, ['name', 'mobile', 'email'])
  if (r.id !== undefined) result.amilia_id = r.id
  return result
}

// Source: https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
_.validateUrl = function(str) {
  if (!str) return false
  var pattern = new RegExp('^(https?:\\/\\/)'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+!$&\'()*,;=:@]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str) && str.length <= 2048
}

_.getYouTubeVideoId = function(url) {
  const match = (url||'').match(/^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/)
  return match && match.length >= 2 ? match[1] : null
}
_.getVimeoVideoId = function(url) {
  const match = (url||'').match(/^\s*https:\/\/vimeo\.com\/([a-zA-Z0-9]+)\/?.*\s*$/)
  return match && match.length == 2 ? match[1] : null
}

_.getVimeoPrivateId = function(url) {
  const match = (url||'').match(/^\s*https:\/\/vimeo\.com\/[a-zA-Z0-9]+\/([a-zA-Z0-9]+)\/?.*\s*$/)
  return match && match.length == 2 ? match[1] : null
}

_.hslToHex = function(h, s, l) {
  h /= 360;
  s /= 100;
  l /= 100;
  let r, g, b;
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  const toHex = x => {
    const hex = Math.round(x * 255).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

_.rgbToHex = function(r, g, b) {
  function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

_.ckeditorColors = function(organization) {
  let colors = [
    {
      color: _.hslToHex(0, 0, 0),
      label: 'Black'
    },
    {
      color: _.hslToHex(0, 0, 30),
      label: 'Dim grey'
    },
    {
      color: _.hslToHex(0, 0, 60),
      label: 'Grey'
    },
    {
      color: _.hslToHex(0, 0, 90),
      label: 'Light grey'
    },
    {
      color: _.hslToHex(0, 0, 100),
      label: 'White',
      hasBorder: true
    },
    {
      color: _.hslToHex(0, 75, 60),
      label: 'Red'
    },
    {
      color: _.hslToHex(30, 75, 60),
      label: 'Orange'
    },
    {
      color: _.hslToHex(60, 75, 60),
      label: 'Yellow'
    },
    {
      color: _.hslToHex(90, 75, 60),
      label: 'Light green'
    },
    {
      color: _.hslToHex(120, 75, 40),
      label: 'Green'
    },
    {
      color: _.hslToHex(150, 75, 60),
      label: 'Aquamarine'
    },
    {
      color: _.hslToHex(180, 75, 60),
      label: 'Turquoise'
    },
    {
      color: _.hslToHex(210, 75, 60),
      label: 'Light blue'
    },
    {
      color: _.hslToHex(240, 75, 60),
      label: 'Blue'
    },
    {
      color: _.hslToHex(270, 75, 60),
      label: 'Purple'
    },
  ]
  if (organization && organization.button_color)
    colors.push({
      color: organization.button_color,
      label: trans('brand_color')
    })
  if (organization && organization.brand_colors && organization.brand_colors.length > 0)
    _.each(organization.brand_colors, c => {
      colors.push({
        color: c,
        label: trans('brand_color')
      })
    })
  return colors;
}

_.ckeditorFontSize = {
  options: [
    10,
    12,
    14,
    15,
    'default',
    18,
    20,
    24,
    32,
    36,
    48,
    64,
    72,
  ],
}

_.activityToString = function(activity) {
  return _.uniq(_.compact([
    activity.program_name,
    activity.category_name,
    activity.subcategory_name,
    activity.team_name || activity.name || activity.activity_name,
    activity.group_name,
  ])).join(', ')
}

_.occurrenceToString = function(occurrence) {
  let staff = _.map(occurrence.staff || [], s => {
    return _.compact([s.name, s.info]).join(' | ')
  })
  return _.compact([
    occurrence.start ? moment(occurrence.start).format('LLL') : null,
    occurrence.start && occurrence.end ? '-' : null,
    occurrence.end ? moment(occurrence.end).format('LLL') : null,
    occurrence.location_name ? ',' : null,
    occurrence.location_name ? occurrence.location_name : null,
    staff.length > 0 ? ',' : null,
    staff.length > 0 ? staff.join(', ') : null,
  ]).join(' ');
}

_.childToString = function(child) {
  let first_name = (child.name|| '').split(' ')[0].trim()
  let gender = child.gender == 'Male' ? trans('boy').toLowerCase() : (child.gender == 'Female' ? trans('girl').toLowerCase() : null)
  let age = moment().diff(child.date_of_birth, 'years')
  return _.compact([first_name, gender, age]).join(', ')
}

_.customToString = function(custom) {
  return _.isArray(custom) ? custom.join(', ') : custom
}

_.personToString = function(person, account_owner) {
  if (!person) return ''
  // check if person is an array
  if (_.isArray(person)) {
    let result = []
    for (let i = 0; i < person.length; i++) {
      result.push(_.personToString(person[i], account_owner))
    }
    return result.join(', ')
  }
  let name = _.fullName(person)
  let postfix = _.compact([
    person.company && name ? person.company : null,
    person.relationship ? trans('contact_type_' + person.relationship).toLowerCase() : null,
    person.gender ? trans('gender_' + person.gender).toLowerCase() : null,
    person.date_of_birth ? moment().diff(person.date_of_birth, 'years') : null,
  ]).join(', ')
  return _.compact([
    name + (postfix ? ` (${postfix})` : ''),
    person.grade ? `${trans('grade')} ${person.grade}` : null,
    !account_owner || person.email != account_owner.email ? person.email : null,
    !account_owner || person.mobile != account_owner.mobile ? person.mobile : null,
    person.address,
    person.other_phone,
    person.can_pickup === true ? `${trans('can_pickup')}: ${trans('yes').toUpperCase()}` : null,
    person.can_pickup === false ? `${trans('can_pickup')}: ${trans('no').toUpperCase()}` : null,
    person.medical ? `${trans('medical_information')}: ${person.medical}` : null,
  ]).join(', ')
}

_.companyToString = function(person, account_owner) {
  if (!person) return ''
  // check if person is an array
  if (_.isArray(person)) {
    let result = []
    for (let i = 0; i < person.length; i++) {
      result.push(_.companyToString(person[i], account_owner))
    }
    return result.join(', ')
  }
  let company = person.company || null
  if (!company) return ''
  return _.compact([
    company,
    person.name,
    person.mobile,
    !account_owner || person.email != account_owner.email ? person.email : null,
    !account_owner || person.mobile != account_owner.mobile ? person.mobile : null,
    person.address,
    person.other_phone,
  ]).join(', ')
}

_.personToHtml = function(person) {
  if (!person) return ''
  let name = _.fullName(person)
  let postfix = _.compact([
    person.company && name ? person.company : null,
    person.relationship ? trans('contact_type_' + person.relationship).toLowerCase() : null,
    person.gender ? trans('gender_' + person.gender).toLowerCase() : null,
    person.date_of_birth ? moment().diff(person.date_of_birth, 'years') : null,
  ]).join(', ')
  let parts = _.compact([
    `<strong>${name}</strong>` + (postfix ? ` (${postfix})` : ''),
    person.grade ? `${trans('grade')} ${person.grade}` : null,
    person.email,
    person.mobile,
    person.address,
    person.other_phone,
    person.can_pickup === true ? `${trans('can_pickup')}: ${trans('yes').toUpperCase()}` : null,
    person.can_pickup === false ? `${trans('can_pickup')}: ${trans('no').toUpperCase()}` : null,
  ])
  return `<address><span class="d-block">${parts.join('</span><span class="d-block">')}</span></address>`
}

_.isSamePerson = function(a, b) {
  if (!a.email || !b.email ||
    _.camelCase(a.email).replace('-', '') != _.camelCase(b.email).replace('-', ''))
    return false

  if (!!a.membership && !!b.membership &&
    a.membership.id == b.membership.id)
    return true

  let a_name = _.camelCase(_.fullName(a)).replace('-', '')
  let b_name = _.camelCase(_.fullName(b)).replace('-', '')
  if (a_name != b_name) return false

  return true
}

_.isSameName = function(a, b) {
  let a_name = _.camelCase(a).replace('-', '')
  let b_name = _.camelCase(b).replace('-', '')
  return a_name == b_name
}

_.loadCanva = function(callback) {
  if (window.canvaApi) {
    callback(window.canvaApi)
    return
  }
  if (!window.canvaApiKey || window.canvaApi !== undefined) return
  window.canvaApi = null
  let script = document.createElement('script');
  script.src = 'https://sdk.canva.com/designbutton/v2/api.js'
  script.onload = () => {
    window.Canva.DesignButton.initialize({
      apiKey: window.canvaApiKey,
    }).then(api => {
      window.canvaApi = api
      callback(window.canvaApi)
    })
  }
  document.body.appendChild(script)
}

// Argument what can be:
// - list: use extra.children directly
// - paper: use extra.paper?.children
// - form: use extra.form?.children
// - waiver: use extra.waiver?.children
_.extractChildrenFromRecipient = function(recipient, what, from, to, use_date_of_birth) {
  if (use_date_of_birth === undefined) use_date_of_birth = true
  let keys = []
  let children = []
  function extract(obj) {
    if (from && to) {
      let date = moment(obj.date || recipient.updated_at, 'YYYY-MM-DD')
      if (date.isBefore(from, 'day') || date.isAfter(to, 'day')) return children
    }
    return _.reduce(obj.children || [], (children, child) => {
      let key = (child.name ?? '').toLowerCase().split(' ')[0] + (use_date_of_birth ? (child.date_of_birth || '') : '')
      if (keys.indexOf(key) === -1) {
        children.push(child)
        keys.push(key)
      }
      return children
    }, children)
  }
  if (what == 'list') return extract(recipient.extra || {})
  return _.reduce(recipient.extra || [], (children, obj, name) => {
    if (name.indexOf(what) === -1 && what == 'form' && name.indexOf('waiver') === -1) return children
    return extract(obj)
  }, children)
}

// Argument what can be:
// - list: use extra.other_guardian directly
// - paper: use extra.paper?.other_guardian
// - form: use extra.form?.other_guardian
// - waiver: use extra.waiver?.other_guardian
_.extractOtherParentsFromRecipient = function(recipient, what, from, to) {
  let used_names = []
  let other_parents = []
  function extract(obj) {
    if (from && to) {
      let date = moment(obj.date || recipient.updated_at, 'YYYY-MM-DD')
      if (date.isBefore(from, 'day') || date.isAfter(to, 'day')) return other_parents
    }
    if (obj.other_guardian) {
      let name = (obj.other_guardian.name||'').trim()
      let email = obj.other_guardian.email ? obj.other_guardian.email.trim() : null
      if (name.length == 0 || recipient.name && name.toLowerCase() != recipient.name.toLowerCase() && used_names.indexOf(name.toLowerCase()) == -1) {
        let parent = name
        if (email && email.toLowerCase() != recipient.email.toLowerCase())
          parent += ' ' + email
        other_parents.push(parent.trim())
        if (parent.length > 0)
          used_names.push(name.toLowerCase())
      }
    }
    return other_parents
  }
  if (what == 'list') return extract(recipient.extra || {})
  return _.reduce(recipient.extra || [], (other_parents, obj, name) => {
    if (name.indexOf(what) === -1 && what == 'form' && name.indexOf('waiver') === -1) return other_parents
    return extract(obj)
  }, other_parents)
}

_.botSettingsAreDirty = function(b1, b2) {
  const attrs = ['to_email', 'to_mobile', 'to_name', 'amilia_event_id', 'invoice_no', 'invoice_url', 'contract_id', 'contract_url', 'ucid']
  // '__ob__' attribute was added by Vue and causes _.isEqual to return false
  return !b1 || !b2 || !_.isEqual(_.omit(JSON.parse(JSON.stringify(b1)), attrs), _.omit(JSON.parse(JSON.stringify(b2)), attrs))
}

_.compareObjects = function(o1, o2){
  for(var p in o1){
      if(o1.hasOwnProperty(p)){
          if(o1[p] !== o2[p]){
            console.log(o1[p], o2[p])
              return false;
          }
      }
  }
  for(var p in o2){
      if(o2.hasOwnProperty(p)){
          if(o1[p] !== o2[p]){
            console.log(o1[p], o2[p])
              return false;
          }
      }
  }
  return true;
};

// returns a moment object
_.parseDate = function(value) {
  if (typeof value != 'string') return moment(value)
  const formats = [
    'YYYY-MM-DD',
    'YYYY-MM-DD HH:mm',
    'YYYY-MM-DD H:mm',
    'YYYY-MM-DD hA',
    'YYYY-MM-DD h:mmA',
    'YYYY-MM-DD hh:mmA',
    'YYYY-M-D',
    'YYYY-M-D HH:mm',
    'YYYY-M-D H:mm',
    'YYYY-M-D hA',
    'YYYY-M-D h:mmA',
    'YYYY-M-D hh:mmA',
    'YYYY-M-D H:mm A',
    'YYYY-MM-DD H:mm A',
    'MM/DD/YYYY',
    'MM/DD/YYYY hA',
    'MM/DD/YYYY h:mmA',
    'MM/DD/YYYY hh:mmA',
    'MM/DD/YYYY H:mm',
    'MM/DD/YYYY HH:mm',
    'M/D/YYYY',
    'M/D/YYYY hA',
    'M/D/YYYY h:mmA',
    'M/D/YYYY hh:mmA',
    'M/D/YYYY H:mm',
    'M/D/YYYY HH:mm',
    'M/D/YYYY H:mm A',
    'D-MMM-YY',
    'D-MMM-YY h:mmA',
    'D-MMM-YY hh:mmA',
    'D-MMM-YY H:mm',
    'D-MMM-YY HH:mm',
    'D-MMM-YY H:mm A',
    'D-MMM-YY h:mm A',
  ]
  let d = moment(value.trim(), formats[0], true)
  let i = 1
  while (!d.isValid() && !!formats[i]) {
    d = moment(value.trim(), formats[i], true)
    i += 1
  }
  return d
}

_.parseTime = function(value) {
  if (typeof value != 'string') return moment(value)
  const formats = [
    'HH:mm',
    'H:mm',
    'hA',
    'h:mmA',
    'hh:mmA',
    'H:mm A',
  ]
  let d = moment(value.trim(), formats[0], true)
  let i = 1
  while (!d.isValid() && !!formats[i]) {
    d = moment(value.trim(), formats[i], true)
    i += 1
  }
  return d
}

_.identifySequenceAndAdjustDateOfEvent = function(clone, events, dateFormat, timeFormat) {
  dateFormat || (dateFormat = 'LL')
  timeFormat || (timeFormat = 'LT')
  // Try to continue a sequence
  let days = 0
  let minutes = 0
  if (events.length >= 2) {
    let previous = events[events.length-2]
    days = Math.abs(moment(clone.start_date, dateFormat).diff(moment(previous.start_date, dateFormat), 'days'))
    if (days == 0) {
      minutes = Math.abs(moment(clone.start_time, timeFormat).diff(moment(previous.start_time, timeFormat), 'minutes'))
    }
  } else {
    days = 1
  }
  if (days > 0)
    clone.start_date = moment(clone.start_date, dateFormat).add(days, 'day').format(dateFormat)
  if (minutes > 0)
    clone.start_time = moment(clone.start_time, timeFormat).add(minutes, 'minute').format(timeFormat)
  return clone
}

_.buildSendCouponEmailBody = function(organization, coupons) {
  let body = ''
  if (!coupons || coupons.length == 0) return body

  if (coupons.length == 1) {
    body += window.lang == 'fr' ?
      `<p>Bonjour,</p><p>Vous avez reçu 1 coupon:</p>` :
      `<p>Hello,</p><p>You have been granted 1 coupon:</p>`
  } else {
    body += window.lang == 'fr' ?
      `<p>Bonjour,</p><p>Vous avez reçu ${coupons.length} coupons:</p>` :
      `<p>Hello,</p><p>You have been granted ${coupons.length} coupons:</p>`
  }

  body += '<p>'
  let packages = []
  let package_ids = []
  let products = []
  let product_ids = []
  _.each(coupons, coupon => {
    packages = _.reduce(coupon.packages, (packages, p) => {
      if (package_ids.indexOf(p.id) === -1) {
        package_ids.push(p.id)
        packages.push(p)
      }
      return packages
    }, packages)
    products = _.reduce(coupon.products, (packages, p) => {
      if (product_ids.indexOf(p.id) === -1) {
        product_ids.push(p.id)
        products.push(p)
      }
      return products
    }, products)
    body += `<span style="border: 1px solid #929fba;font-family:'Courier New', Courier, monospace;font-size:32px;padding:3px;display:inline-block;margin-bottom:5px;"><strong>${coupon.code}</strong></span>&nbsp;`
  })
  body += '</p>'

  if (coupons.length == 1) {
    body += window.lang == 'fr' ?
      `<p>Ce coupon est échangeable contre l'un de ces items:</p><ul>` :
      `<p>This coupon is redeemable against one of these items:</p><ul>`
  } else {
    body += window.lang == 'fr' ?
      `<p>Ces coupons sont échangeable contre l'un de ces items:</p><ul>` :
      `<p>These coupons are redeemable against one of these items:</p><ul>`
  }

  _.each(packages, p => {
    body += `<li><a href="${organization.microsite_url}/package/${p.id}?${window.lang}">${p.name}</a></li>`
  })
  _.each(products, p => {
    body += `<li><a href="${organization.microsite_url}/products?${window.lang}">${p.name}</a></li>`
  })

  body += window.lang == 'fr' ?
    `</ul><p>Accedez à tous vos coupons dans votre <a href="${organization.microsite_url}/client?fr">compte client</a>.</p>` :
    `</ul><p>To access all of your coupons, go to your <a href="${organization.microsite_url}/client">client account</a>.</p>`

  body += `<p>${organization.alias}</p>`
  return body
}

// Overcome a bug with spectrum.js which stacks color palette buttons on top of each other.
_.fixPalette = function(palette) {
  if (!palette) return palette
  return _.map(palette, color => {
    return [color]
  })
}

_.printAge = function(date_of_birth, ref_date, locale) {
  if (!date_of_birth) return date_of_birth
  let years = Math.abs(moment(date_of_birth).diff(moment(ref_date || undefined), 'years'))
  let months = Math.abs(moment(date_of_birth).diff(moment(ref_date || undefined), 'months')) % 12
  locale || (locale = lang)
  let y = locale == 'fr' ? 'a' : 'y'
  let result = `${years}${y}`
  if (years < 18 && months > 0) result +=  ` ${months}m`
  return result
}

_.printAgeConstraint = function(constraint, organization) {
  if (!constraint ||
    !constraint.min_years && !constraint.min_months && !constraint.max_years && !constraint.max_months && !constraint.use_min_max_date_of_birth && !constraint.min_date_of_birth && !constraint.max_date_of_birth)
    return null

  if (constraint.use_min_max_date_of_birth) {
    let parts = []
    // Born on or after :min.
    if (constraint.min_date_of_birth) {
      parts.push(`${trans('born_on_or_after').replace(':date', moment(constraint.min_date_of_birth).format('LL'))}`)
    }
    // Born before or on :max.
    if (constraint.max_date_of_birth) {
      parts.push(`${trans('born_before_or_on').replace(':date', moment(constraint.max_date_of_birth).format('LL'))}`)
    }
    if (constraint.note) {
      parts.push(constraint.note)
    }
    return parts.join(' ')
  }

  let parts = []
  let part = ''
  if (constraint.min_years || constraint.min_months) {
    part = `${trans('min_age').toLowerCase()} `
    if (constraint.min_years) part += ` ${constraint.min_years} ${trans('age_year' + (constraint.min_years > 1 ? 's' : '')).toLowerCase()}`
    if (constraint.min_months) part += ` ${constraint.min_months} ${trans('month' + (constraint.min_months > 1 ? 's' : '')).toLowerCase()}`
    parts.push(part)
  }
  if (constraint.max_years || constraint.max_months) {
    part = `${trans('max_age_less_than').toLowerCase()} `
    let maxYears = constraint.max_years
    if (organization && organization.has_one_year_age_display) {
      if (maxYears > 1) {
        maxYears -= 1
      }
    }
    if (constraint.max_years) part += ` ${maxYears} ${trans('age_year' + (maxYears > 1 ? 's' : '')).toLowerCase()}`
    if (constraint.max_months) part += ` ${constraint.max_months} ${trans('month' + (constraint.max_months > 1 ? 's' : '')).toLowerCase()}`
    parts.push(part)
  }
  if (constraint.date_of && !constraint.age_at_start && !constraint.age_at_end_of_the_year) {
    part = `${trans('as_of').toLowerCase()} ${moment(constraint.date_of).format('LL')}`
    parts.push(part)
  }
  if (constraint.age_at_start && !constraint.age_at_end_of_the_year) {
    parts.push(trans('at_start_of_class'))
  }
  if (constraint.age_at_end_of_the_year && !constraint.age_at_start) {
    part = `${trans('as_of').toLowerCase()} ${moment().endOf('year').format('LL')}`
    parts.push(part)
  }

  let result = _.capitalize(parts.join(', ')) + '.'
  if (constraint.note) result += ' ' + constraint.note
  return result
}

_.allPersonAttributes = [
    'company', 'relationship',
    'first_name', 'last_name', 'email', 'mobile', 'gender', 'date_of_birth',
    'grade', 'pickup_password', 'friend', 'medical', 'medical_conditions', 'allergies',
    'address1', 'city', 'state_province', 'zip_postal_code', 'other_phone', 'zip_postal_code',
]

_.allGenderChoices = ['Male', 'Female', 'Transmasculine', 'Transfeminine', 'NonBinary', 'NotSpecified', 'TwoSpirit', 'Other', 'PreferNotToSay']
_.printGenderChoices = function(gender_choices) {
  if (!gender_choices || gender_choices.length == 0) return trans('any')
  return _.map(gender_choices, gender => {
    return trans('gender_' + gender)
  }).join(', ')
}
_.serializeGender = function(gender) {
  if (!gender) return gender
  switch (gender.toLowerCase()) {
    case 'masculin':
    case 'homme':
    case 'garçon':
    case 'male':
    case 'boy':
      return 'Male'
    case 'féminin':
    case 'femme':
    case 'fille':
    case 'female':
    case 'girl':
      return 'Female'
    case 'transmasculin':
    case 'transmasculine':
      return 'Transmasculine'
    case 'transféminin':
    case 'transfeminine':
      return 'Transfeminine'
    case 'non binaire':
    case 'non binary':
      return 'NonBinary'
    case 'non spécifié':
    case 'not specified':
      return 'NotSpecified'
    case 'préfère ne pas dire':
    case 'prefer not to say':
      return 'PreferNotToSay'
    case 'bispirituel(le)':
    case 'two spirit':
      return 'TwoSpirit'
    case 'other':
    case 'autre':
      return 'Other'
  }
  return gender
}

_.allRelationshipChoices = ['parent', 'step_parent', 'mother', 'father', 'child', 'grandmother', 'grandfather', 'aunt', 'uncle', 'sibling', 'colleague', 'friend', 'neighbor', 'partner', 'other']
_.printRelationshipChoices = function(relationship_choices) {
  if (!relationship_choices || relationship_choices.length == 0) return trans('any')
  return _.map(relationship_choices, relationship => {
    return trans('contact_type_' + relationship)
  }).join(', ')
}
_.serializeRelationship = function(relationship) {
  if (!relationship) return relationship
  relationship = _.slugify(_.removeDiacritics(relationship.toLowerCase().trim())).replace(/-/g, '')
  switch (relationship) {
    case 'child':
    case 'enfant':
      return 'child'
    case 'parent':
      return 'parent'
    case 'stepparent':
    case 'beauparent':
      return 'step_parent'
    case 'mother':
    case 'mere':
      return 'mother'
    case 'father':
    case 'pere':
      return 'father'
    case 'grandmother':
    case 'grandmere':
      return 'grandmother'
    case 'grandfather':
    case 'grandpere':
      return 'grandfather'
    case 'aunt':
    case 'tante':
      return 'aunt'
    case 'uncle':
    case 'oncle':
      return 'uncle'
    case 'sibling':
    case 'freresoeur':
      return 'sibling'
    case 'colleague':
    case 'collegue':
      return 'colleague'
    case 'friend':
    case 'ami':
    case 'amie':
      return 'friend'
    case 'neighbor':
    case 'voisin':
      return 'neighbor'
    case 'partner':
    case 'conjoint':
    case 'conjointe':
      return 'partner'
    case 'other':
    case 'autre':
      return 'other'
  }
  return relationship
}

_.allAllergyChoices = ['none', 'nuts', 'eggs', 'seafood', 'peanuts', 'insects']
_.printAllergyChoices = function(choices) {
  if (!choices || choices.length == 0) return null
  return _.map(choices, v => {
    if (_.allAllergyChoices.indexOf(v) >= 0) return trans(v)
    return v
  }).join(', ')
}
_.serializeAllergies = function(text) {
  let values = (text||'').split(',')
  let others = []
  let allergies = _.reduce(values, (allergies, value) => {
    value = _.slugify((value||'').trim()).replace(/-/g, '')
    if (!value) return allergies
    let allergy = null
    switch(value) {
      case 'none':
      case 'no':
      case 'aucun':
      case 'aucune':
      case 'non':
        allergy = 'none'
        break;
      case 'nuts':
      case 'noix':
        allergy = 'nuts'
        break;
      case 'eggs':
      case 'oeufs':
        allergy = 'eggs'
        break;
      case 'seafood':
      case 'fruitsdemers':
        allergy = 'seafood'
        break;
      case 'peanuts':
      case 'arachides':
        allergy = 'peanuts'
        break;
      case 'insectbitesstings':
      case 'insect':
      case 'insects':
      case 'insecte':
      case 'insectes':
      case 'piquresdinsectes':
        allergy = 'insects'
        break;
    }
    if (!!allergy && allergies.indexOf(allergy) === -1) allergies.push(allergy)
    if (!allergy && others.indexOf(value) === -1) others.push(value)
    return allergies
  }, [])
  return _.union(allergies, others)
}

_.allMedicalConditionChoices = ['none', 'asthma', 'hearing_disorder', 'hyperactive', 'visual_disorder', 'incontinence', 'diabetes', 'epilepsy']
_.printMedicalConditionChoices = function(choices) {
  if (!choices || choices.length == 0) return null
  if (!_.isArray(choices)) return choices
  return _.map(choices, v => {
    if (_.allMedicalConditionChoices.indexOf(v) >= 0) return trans(v)
    return v
  }).join(', ')
}
_.serializeMedicalConditions = function(text) {
  let values = (text||'').split(',')
  let others = []
  let conditions = _.reduce(values, (conditions, value) => {
    value = _.slugify((value||'').trim()).replace(/-/g, '')
    if (!value) return conditions
    let condition = null
    switch(value) {
      case 'none':
      case 'no':
      case 'aucun':
      case 'aucune':
      case 'non':
        condition = 'none'
        break;
      case 'asthma':
      case 'asthme':
        condition = 'asthma'
        break;
      case 'hearingdisorder':
      case 'troubleauditif':
        condition = 'hearing_disorder'
        break;
      case 'hyperactive':
      case 'hyperactivite':
      case 'hyperactif':
        condition = 'hyperactive'
        break;
      case 'visualdisorder':
      case 'troublevisuel':
        condition = 'visual_disorder'
        break;
      case 'incontinence':
        condition = 'incontinence'
        break;
      case 'diabetes':
      case 'diabete':
        condition = 'diabetes'
        break;
      case 'epilepsy':
      case 'epilepsie':
        condition = 'epilepsy'
        break;
    }
    if (!!condition && conditions.indexOf(condition) === -1) conditions.push(condition)
    if (!condition && others.indexOf(value) === -1) others.push(value)
    return conditions
  }, [])
  return _.union(conditions, others)
}

_.validateAgeConstraint = function(date_of_birth, constraint, season = null) {
  if (!constraint ||
    !constraint.min_years && !constraint.min_months && !constraint.max_years && !constraint.max_months && !constraint.use_min_max_date_of_birth && !constraint.min_date_of_birth && !constraint.max_date_of_birth)
    return null

  let dob = moment(date_of_birth)

  if (constraint.use_min_max_date_of_birth) {
    if (constraint.min_date_of_birth &&
      dob.isBefore(constraint.min_date_of_birth))
      return false
    if (constraint.max_date_of_birth &&
      dob.isAfter(constraint.max_date_of_birth))
      return false
    return true
  }

  if (season) {
    let year = dob.year()
    let diff = season - year
    if (constraint.min_years && constraint.min_years > diff) return false
    if (constraint.max_years && constraint.max_years < diff) return false
    return true
  }

  let check_at = constraint.date_of ? moment(constraint.date_of) : moment()
  let min_at = null
  if (constraint.min_years || constraint.min_months) {
    min_at = moment(check_at)
    if (constraint.min_years) min_at.add(-constraint.min_years, 'years')
    if (constraint.min_months) min_at.add(-constraint.min_months, 'months')
  }
  let max_at = null
  if (constraint.max_years || constraint.max_months) {
    max_at = moment(check_at)
    if (constraint.max_years) max_at.add(-constraint.max_years, 'years')
    if (constraint.max_months) max_at.add(-constraint.max_months, 'months')
  }
  /*console.log({
    date_of_birth: date_of_birth,
    dob: dob.toISOString(),
    check_at: check_at.toISOString(),
    min_at: min_at ? min_at.toISOString() : null,
    max_at: max_at ? max_at.toISOString() : null,
  })*/
  if (min_at && dob.isAfter(min_at) || max_at && dob.isSameOrBefore(max_at)) return false
  return true
}

// http://jsperf.com/diacritics/12
_.removeDiacritics = function(str) {
    var defaultDiacriticsRemovalMap = [
        {'base':'A', 'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
        {'base':'AA','letters':'\uA732'},
        {'base':'AE','letters':'\u00C6\u01FC\u01E2'},
        {'base':'AO','letters':'\uA734'},
        {'base':'AU','letters':'\uA736'},
        {'base':'AV','letters':'\uA738\uA73A'},
        {'base':'AY','letters':'\uA73C'},
        {'base':'B', 'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
        {'base':'C', 'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
        {'base':'D', 'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\u00D0'},
        {'base':'DZ','letters':'\u01F1\u01C4'},
        {'base':'Dz','letters':'\u01F2\u01C5'},
        {'base':'E', 'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
        {'base':'F', 'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
        {'base':'G', 'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
        {'base':'H', 'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
        {'base':'I', 'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
        {'base':'J', 'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
        {'base':'K', 'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
        {'base':'L', 'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
        {'base':'LJ','letters':'\u01C7'},
        {'base':'Lj','letters':'\u01C8'},
        {'base':'M', 'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
        {'base':'N', 'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
        {'base':'NJ','letters':'\u01CA'},
        {'base':'Nj','letters':'\u01CB'},
        {'base':'O', 'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
        {'base':'OI','letters':'\u01A2'},
        {'base':'OO','letters':'\uA74E'},
        {'base':'OU','letters':'\u0222'},
        {'base':'OE','letters':'\u008C\u0152'},
        {'base':'oe','letters':'\u009C\u0153'},
        {'base':'P', 'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
        {'base':'Q', 'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
        {'base':'R', 'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
        {'base':'S', 'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
        {'base':'T', 'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
        {'base':'TZ','letters':'\uA728'},
        {'base':'U', 'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
        {'base':'V', 'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
        {'base':'VY','letters':'\uA760'},
        {'base':'W', 'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
        {'base':'X', 'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
        {'base':'Y', 'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
        {'base':'Z', 'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
        {'base':'a', 'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
        {'base':'aa','letters':'\uA733'},
        {'base':'ae','letters':'\u00E6\u01FD\u01E3'},
        {'base':'ao','letters':'\uA735'},
        {'base':'au','letters':'\uA737'},
        {'base':'av','letters':'\uA739\uA73B'},
        {'base':'ay','letters':'\uA73D'},
        {'base':'b', 'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
        {'base':'c', 'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
        {'base':'d', 'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
        {'base':'dz','letters':'\u01F3\u01C6'},
        {'base':'e', 'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
        {'base':'f', 'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
        {'base':'g', 'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
        {'base':'h', 'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
        {'base':'hv','letters':'\u0195'},
        {'base':'i', 'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
        {'base':'j', 'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
        {'base':'k', 'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
        {'base':'l', 'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
        {'base':'lj','letters':'\u01C9'},
        {'base':'m', 'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
        {'base':'n', 'letters':'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
        {'base':'nj','letters':'\u01CC'},
        {'base':'o', 'letters':'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
        {'base':'oi','letters':'\u01A3'},
        {'base':'ou','letters':'\u0223'},
        {'base':'oo','letters':'\uA74F'},
        {'base':'p','letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
        {'base':'q','letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
        {'base':'r','letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
        {'base':'s','letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
        {'base':'t','letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
        {'base':'tz','letters':'\uA729'},
        {'base':'u','letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
        {'base':'v','letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
        {'base':'vy','letters':'\uA761'},
        {'base':'w','letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
        {'base':'x','letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
        {'base':'y','letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
        {'base':'z','letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
    ];
    var diacriticsMap = {};
    for (var i=0; i < defaultDiacriticsRemovalMap .length; i++){
        var letters = defaultDiacriticsRemovalMap [i].letters;
        for (var j=0; j < letters.length ; j++){
            diacriticsMap[letters[j]] = defaultDiacriticsRemovalMap [i].base;
        }
    }
    return str.replace(/[^\u0000-\u007E]/g, function(a){
       return diacriticsMap[a] || a;
    });
}

// Sportplus
// Parse something like this...
// Jeudi 17:00 à 17:45 Du 2022-02-17 Jusqu'au 2022-04-28
_.extractOccurrencesFromActivityName = function(activity_name) {
  let occurrences = []
  if (!activity_name) return occurrences
  let times = activity_name.match(/(\d\d:\d\d)/g)
  let dates = activity_name.match(/(\d\d\d\d-\d\d-\d\d)/g)
  let start_time, end_time

  function push(start) {
    let occurrence = {
      name: start.format('LLLL'),
      start: start.toISOString(),
    }
    if (start_time != end_time) {
      occurrence.end = moment(start.format('YYYY-MM-DD') + ' ' + end_time).toISOString()
    }
    occurrences.push(occurrence)
  }

  if (times && times.length == 2 && dates && dates.length == 2) {
    start_time = times[0]
    let start_date = dates[0]
    end_time = times[1]
    let end_date = dates[1]
    let start = moment(start_date + ' ' + start_time)
    let end = moment(end_date + ' ' + start_time)
    push(start)
    let cursor = moment(start).add(7, 'days')
    while (cursor.isBefore(end)) {
      push(cursor)
      cursor.add(7, 'days')
    }
    if (!end.isSame(start)) {
      push(end)
    }
  }
  return occurrences
}

_.normalizeSkytechAnswer = function(value) {
  if (!value || ['n/a'].indexOf(value.toLowerCase()) >= 0) return null
  if (['no'].indexOf(value.toLowerCase()) >= 0) return 'No'
  if (['y', 'yes'].indexOf(value.toLowerCase()) >= 0) return 'Yes'
  if (['n', 'non'].indexOf(value.toLowerCase()) >= 0) return 'Non'
  if (['o', 'oui'].indexOf(value.toLowerCase()) >= 0) return 'Oui'
  return value
}

_.classPrice = function(am_class, question) {
  return _.isNumeric(question.options.price) ?
    question.options.price :
    (_.isNumeric(am_class.price) ? am_class.price : null)
}

_.promoCodeReduction = function(promo_code, price) {
  return promo_code.type == 'amount' ?
    promo_code.amount :
    price * promo_code.percentage
}

_.proRataPrice = function(pro_rata, price, events) {
  if (!price || events.length <= 1) return price
  let reduction = pro_rata.type == 'amount' ?
    pro_rata.amount :
    price * pro_rata.percentage
  let i = 0
  let now = moment()
  while (price > pro_rata.minimum && !!events[i] && !now.isBefore(events[i].end || events[i].start)) {
    price -= reduction
    i += 1
  }
  if (price < pro_rata.minimum) price = pro_rata.minimum
  return price
}

_.printProRataHtml = function(pro_rata, price, events) {
  // Initial price of 100$ gets reduced by 10$ after every class.
  let what = pro_rata.type == 'amount' ?
    _.currency(pro_rata.amount) :
    numeral(pro_rata.percentage).format('0.[00]%')
  let text = trans('pro_rata_preview')
    .replace(':price', _.currency(price))
    .replace(':what', what)
  let html = `<p>${text}</p>`

  if (!!events && events.length > 0) {
    // 100$ before 10am, Oct 10, 2022
    // 90$ after 10am, Oct 10, 2022
    // 80$ after 10am, Oct 17, 2022
    // ...
    html += '<ul>'
    html += `<li>${_.currency(price)} ${trans('before').toLowerCase()} ${moment(events[0].start).format('LLL')}`
    let reduction = pro_rata.type == 'amount' ?
      pro_rata.amount :
      price * pro_rata.percentage
    let i = 0
    while (price > pro_rata.minimum && !!events[i]) {
      price -= reduction
      if (price < pro_rata.minimum) price = pro_rata.minimum
      html += `<li>${_.currency(price)} ${trans('after').toLowerCase()} ${moment(events[i].end || events[i].start).format('LLL')}`
      i += 1
    }
    html += '</ul>'
  }

  return html
}

_.printMembershipDuration = function(membership) {
  if (!membership) return null
  if (membership.duration_type == 'month')
    return `${membership.duration} ${trans('month' + (membership.duration > 1 ? 's' : ''))}`
  if (membership.duration_type == 'fixed')
    return `${moment(membership.active_at).format('LL')} - ${moment(membership.expired_at).format('LL')}`
  return null
}

_.printGiftCardNo = function(o, g) {
  let organization_id = _.isObject(o) ? o.id : o
  let gift_card_no = _.isObject(g) ? g.gift_card_no : g
  return numeral(organization_id).format('00000') + '-' + numeral(gift_card_no).format('00000')
}

// Sames logic as PHP helper's print_person - keep in sync!
_.printPerson = function(person, attrs) {
  let result = person.name
  if (_.isArray(attrs) && attrs.length > 0) {
    let parts = _.reduce(attrs, (parts, attr) => {
      if (attr == 'name') return parts
      if (attr == 'gender' && !!person[attr]) {
        parts.push(trans('gender_' + person[attr]).toLowerCase())
        return parts
      }
      if (!!person[attr]) parts.push(person[attr])
      return parts
    }, [])
    if (parts.length > 0) {
      result += ` (${parts.join(', ')})`
    }
  }
  return result
}

_.calendarColors = [
  {variant: 'primary', color: '#B8DCEE'},
  {variant: 'danger', color: '#FCDAB8'},
  {variant: 'success', color: '#C1E9CD'},
  {variant: 'info', color: '#FB9EBE'},
  {variant: 'light', color: '#d0d6e2'},
  {variant: 'secondary', color: '#929FBA'},
  //{variant: 'text', color: '#45526e'},
  //{variant: 'muted', color: '#7283a7'},
]

_.trackingStatusColors = [
  {variant: 'primary', color: '#B8DCEE'},
  {variant: 'danger', color: '#FCDAB8'},
  {variant: 'success', color: '#C1E9CD'},
  {variant: 'info', color: '#FB9EBE'},
  {variant: 'light', color: '#d0d6e2'},
  {variant: 'secondary', color: '#929FBA'},
]

_.defaultTrackingStatusOptions = [
  {
    name: trans('present'),
    variant: _.trackingStatusColors[2].variant, // success
    color: _.trackingStatusColors[2].color,
  },
  {
    name: trans('absent'),
    variant: _.trackingStatusColors[1].variant, // danger
    color: _.trackingStatusColors[1].color,
  },
]

_.badCharacters = ':"`\\[]<>&;'
_.hasBadCharacters = function(str) {
  if (!str) return false
  return str.indexOf(':') >= 0 ||
    //str.indexOf(',') >= 0 ||
    //str.indexOf('.') >= 0 ||
    //str.indexOf("'") >= 0 ||
    str.indexOf('"') >= 0 ||
    str.indexOf('`') >= 0 ||
    str.indexOf('\\') >= 0 ||
    str.indexOf('[') >= 0 ||
    str.indexOf(']') >= 0 ||
    str.indexOf('>') >= 0 ||
    str.indexOf('<') >= 0 ||
    str.indexOf('&') >= 0 ||
    str.indexOf(';') >= 0
}

_.yesNoOptions = [
  {value: true, text: trans('yes')},
  {value: false, text: trans('no')},
]

_.isYes = function(value) {
  if (!value) return false
  return ['yes', 'oui'].indexOf(value.toLowerCase()) >= 0
}

_.buildBlockFromClass = function(cls) {
  let name_placeholder = window.lang == 'fr' ? '{Cours}' : '{Class}'
  let text = `<h5 style="text-align:center;"><span class="placeholder">${name_placeholder}</span></h5>`
  let price = cls.price
  let price_rule_1 = null
  let price_rule_2 = null
  let price_rule_3 = null
  let price_min = _.reduce(cls.microsite_registration_questions, (price_min, q, index) => {
    if (q.options.price !== null && q.options.price < price_min) price_min = q.options.price
    if (index == 1) price_rule_1 = q.options.price
    if (index == 2) price_rule_2 = q.options.price
    if (index == 3) price_rule_3 = q.options.price
    return price_min
  }, price)
  let price_max = _.reduce(cls.microsite_registration_questions, (price_max, q) => {
    if (q.options.price !== null && q.options.price > price_max) price_max = q.options.price
    return price_max
  }, price)
  let price_min_placeholder = window.lang == 'fr' ? '{Prix min}' : '{Price min}'
  let price_placeholder = window.lang == 'fr' ? '{Prix}' : '{Price}'
  if (price_min < price_max)
    text += `<h5 style="text-align:center;"><span style="font-weight:normal;">${trans('starting_from').replace(':value', '')}</span><span class="placeholder">${price_min_placeholder}</span></h5>`
  else
    text += `<h3 style="text-align:center;"><span class="placeholder">${price_placeholder}</span></h3>`
  return {
    type: 'am-class-card',
    text: text,
    button_text: trans('register'),
    button_url: '#',
    button_color: null,
    button_target: null,
    image_url: cls.image_url,
    image_media_id: null,
    image_alt: null,
    image_cta_url: null,
    image_percent: 0.3333,
    image_pexels: null,
    span_row: false,
    h_align: 'center',
    meta: null,
    am_class_id: cls.id,
    am_class_name: cls.name,
    am_class_prices: {price, price_min, price_max, price_rule_1, price_rule_2, price_rule_3},
  }
}

_.createPageBlockPlaceholders = function(block) {
  let activity = block.type == 'amilia-activity' ? block.meta : null
  let responsible = activity ? activity.responsible_name || null : null
  let occurrence = activity && activity.occurrences ?
    activity.occurrences[0] :
    null

  let start = occurrence && occurrence.start ?
    moment(occurrence.start) :
    (activity ? moment(activity.start) : null)
  let end = occurrence && occurrence.end ?
    moment(occurrence.end) :
    (activity ? moment(activity.end) : null)

  let staff_names = null
  let staff_first_names = null
  if (occurrence && occurrence.staff && occurrence.staff.length > 0) {
    staff_names = _.reduce(occurrence.staff, (names, staff) => {
      names.push(staff.name)
      return names
    }, []).join(', ')
    staff_first_names = _.reduce(occurrence.staff, (names, staff) => {
      names.push(staff.first_name)
      return names
    }, []).join(', ')
  }

  let dates = null
  let now = moment()
  let next = null
  if (activity && activity.occurrences) {
    let lis = _.map(activity.occurrences, o => {
      let d = moment(o.start)
      if (d.isSameOrAfter(now) && (!next || d.isBefore(next))) {
        next = d
      }
      return `<li>${d.format('LLL')}</li>`
    }).join('')
    dates = `<ul>${lis}</ul>`
    if (activity.occurrences.length > 0) {
      let o = activity.occurrences[activity.occurrences.length-1]
      end = o.end ? moment(o.end) : end
    }
  }

  let membership = block.type == 'amilia-membership' ? block.meta : null

  let program = block.type == 'amilia-program' ? block.meta : null
  if (program) {
    start = program.start ? moment(program.start) : null
    end = program.end ? moment(program.end) : null
  }

  let name = null
  let short_description = null
  if (block.type == 'package-card') {
    name = block.package_name
    short_description = block.package_short_description
  }
  if (block.type == 'form-card') {
    name = block.form_name
  }

  let cls = null
  if (block.type == 'am-class-card') {
    cls = _.assign({name: block.am_class_name}, block.am_class_prices)
    name = cls.name
  }

  return {
    'activity': activity ? (activity.name || activity.activity_name) : '',
    'subcategory': activity ? activity.subcategory_name : '',
    'category': activity ? activity.category_name : '',
    'program': program ? program.name : (activity ? activity.program_name : ''),
    'responsible': responsible || '',
    'schedule' : activity ? activity.schedule_summary : '',
    'start date/time': start ? start.format('LLL') : '',
    'end date/time': end ? end.format('LLL') : '',
    'start date': start ? start.format('LL') : '',
    'end date': end ? end.format('LL') : '',
    'start time': start ? start.format('LT') : '',
    'end time': end ? end.format('LT') : '',
    'next date/time': next ? next.format('LLL') : '',
    'next date': next ? next.format('LL') : '',
    'next time': next ? next.format('LT') : '',
    'all dates': dates ? dates : '',
    'spots left': activity && activity.spots_remaining > 0 ? activity.spots_remaining : '',
    'location': occurrence && occurrence.location_name ? (occurrence.location_name||'') : '',
    'staff name(s)': staff_names || '',
    'staff first name(s)': staff_first_names || '',
    'membership': membership ? membership.name : '',
    'name': name ? name : '',
    'short description': short_description ? short_description : null,
    'class': cls ? cls.name : null,
    'price': cls ? _.currency(cls.price, null, 'en') : null,
    'price min': cls ? _.currency(cls.price_min, null, 'en') : null,
    'price max': cls ? _.currency(cls.price_max, null, 'en') : null,
    'price rule 1': cls && _.isNumeric(cls.price_rule_1) ? _.currency(cls.price_rule_1, null, 'en') : null,
    'price rule 2': cls && _.isNumeric(cls.price_rule_2) ? _.currency(cls.price_rule_2, null, 'en') : null,
    'price rule 3': cls && _.isNumeric(cls.price_rule_3) ? _.currency(cls.price_rule_3, null, 'en') : null,

    'activite': activity ? (activity.name || activity.activity_name) : '',
    'sous-categorie': activity ? activity.subcategory_name : '',
    'categorie': activity ? activity.category_name : '',
    'programmation': program ? program.name : (activity ? activity.program_name : ''),
    'responsable': responsible || '',
    'horaire' : activity ? activity.schedule_summary : '',
    'date/heure de debut': start ? start.format('LLL') : '',
    'date/heure de fin': end ? end.format('LLL') : '',
    'date de debut': start ? start.format('LL') : '',
    'date de fin': end ? end.format('LL') : '',
    'heure de debut': start ? start.format('LT') : '',
    'heure de fin': end ? end.format('LT') : '',
    'date/heure du prochain': next ? next.format('LLL') : '',
    'date du prochain': next ? next.format('LL') : '',
    'heure du prochain': next ? next.format('LT') : '',
    'les dates': dates ? dates : '',
    'places disponibles': activity && activity.spots_remaining > 0 ? activity.spots_remaining : '',
    'lieu': occurrence && occurrence.location_name ? (occurrence.location_name||'') : '',
    'nom(s) du personnel': staff_names || '',
    'prenom(s) du personnel': staff_first_names || '',
    'abonnement': membership ? membership.name : '',
    'affiliation': membership ? membership.name : '',
    'nom': name ? name : '',
    'courte description': short_description ? short_description : null,
    'cours': cls ? cls.name : null,
    'prix': cls ? _.currency(cls.price, null, 'fr') : null,
    'prix min': cls ? _.currency(cls.price_min, null, 'fr') : null,
    'prix max': cls ? _.currency(cls.price_max, null, 'fr') : null,
    'prix regle 1': cls && _.isNumeric(cls.price_rule_1) ? _.currency(cls.price_rule_1, null, 'fr') : null,
    'prix regle 2': cls && _.isNumeric(cls.price_rule_2) ? _.currency(cls.price_rule_2, null, 'fr') : null,
    'prix regle 3': cls && _.isNumeric(cls.price_rule_3) ? _.currency(cls.price_rule_3, null, 'fr') : null,
  }
}

_.provinces = ['AB', 'BC', 'MB', 'NB', 'NF', 'NL', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']
_.stateProvinceOptions = [
  {value: null, text: trans('none')},
  {value: 'AB', text: 'Alberta'},
  {value: 'BC', text: window.lang == 'fr' ? 'Colombie-Britannique' : 'British Columbia'},
  {value: 'MB', text: 'Manitoba'},
  {value: 'NB', text: window.lang == 'fr' ? 'Nouveau-Brunswick' : 'New Brunswick'},
  {value: 'NF', text: window.lang == 'fr' ? 'Terre-Neuve' : 'Newfoundland'},
  {value: 'NS', text: window.lang == 'fr' ? 'Nouvelle-Écosse' : 'Nova Scotia'},
  {value: 'NT', text: window.lang == 'fr' ? 'Territoires du Nord-Ouest' : 'Northwest Territories'},
  {value: 'ON', text: 'Ontario'},
  {value: 'PE', text: window.lang == 'fr' ? 'Île-du-Prince-Édouard' : 'Prince Edward Island'},
  {value: 'QC', text: 'Québec'},
  {value: 'SK', text: 'Saskatchewan'},
  {value: 'YT', text: 'Yukon '},
  {value: 'AK', text: 'ALASKA'},
  {value: 'AL', text: 'ALABAMA'},
  {value: 'AR', text: 'ARKANSAS'},
  {value: 'AS', text: 'AMERICAN SAMOA'},
  {value: 'AZ', text: 'ARIZONA'},
  {value: 'CA', text: 'CALIFORNIA'},
  {value: 'CO', text: 'COLORADO'},
  {value: 'CT', text: 'CONNECTICUT'},
  {value: 'DC', text: 'WASHINGTON, DISTRICT OF COLUMBIA'},
  {value: 'DE', text: 'DELAWARE'},
  {value: 'FL', text: 'FLORIDA'},
  {value: 'FM', text: 'FEDERATED STATES OF MICRONESIA'},
  {value: 'GA', text: 'GEORGIA'},
  {value: 'GU', text: 'GUAM'},
  {value: 'HI', text: 'HAWAII'},
  {value: 'IA', text: 'IOWA'},
  {value: 'ID', text: 'IDAHO'},
  {value: 'IL', text: 'ILLINOIS'},
  {value: 'IN', text: 'INDIANA'},
  {value: 'KS', text: 'KANSAS'},
  {value: 'KY', text: 'KENTUCKY'},
  {value: 'LA', text: 'LOUISIANA'},
  {value: 'MA', text: 'MASSACHUSETTS'},
  {value: 'MD', text: 'MARYLAND'},
  {value: 'ME', text: 'MAINE'},
  {value: 'MH', text: 'MARSHALL ISLANDS'},
  {value: 'MI', text: 'MICHIGAN'},
  {value: 'MN', text: 'MINNESOTA'},
  {value: 'MO', text: 'MISSOURI'},
  {value: 'MP', text: 'NORTHERN MARIANA ISLANDS'},
  {value: 'MS', text: 'MISSISSIPPI'},
  {value: 'MT', text: 'MONTANA'},
  {value: 'NC', text: 'NORTH CAROLINA'},
  {value: 'ND', text: 'NORTH DAKOTA'},
  {value: 'NE', text: 'NEBRASKA'},
  {value: 'NH', text: 'NEW HAMPSHIRE'},
  {value: 'NJ', text: 'NEW JERSEY'},
  {value: 'NM', text: 'NEW MEXICO'},
  {value: 'NV', text: 'NEVADA'},
  {value: 'NY', text: 'NEW YORK'},
  {value: 'OH', text: 'OHIO'},
  {value: 'OK', text: 'OKLAHOMA'},
  {value: 'OR', text: 'OREGON'},
  {value: 'PA', text: 'PENNSYLVANIA'},
  {value: 'PR', text: 'PUERTO RICO'},
  {value: 'PW', text: 'PALAU'},
  {value: 'RI', text: 'RHODE ISLAND'},
  {value: 'SC', text: 'SOUTH CAROLINA'},
  {value: 'SD', text: 'SOUTH DAKOTA'},
  {value: 'TN', text: 'TENNESSEE'},
  {value: 'TX', text: 'TEXAS'},
  {value: 'UT', text: 'UTAH'},
  {value: 'VA', text: 'VIRGINIA'},
  {value: 'VI', text: 'VIRGIN ISLANDS'},
  {value: 'VT', text: 'VERMONT'},
  {value: 'WA', text: 'WASHINGTON'},
  {value: 'WI', text: 'WISCONSIN'},
  {value: 'WV', text: 'WEST VIRGINIA'},
  {value: 'WY', text: 'WYOMING'},
]

_.membershipNo = function(id, membership_no, type) {
  if (type == 'cogesport' && !!membership_no) return `00${membership_no}010020`
  return membership_no || id
}

_.membershipNoDisplay = function(id, membership_no, type) {
  if (type == 'cogesport' && !!membership_no) return `${membership_no}-01-0020`
  return membership_no || `AM-${id}`
}

_.noteHasTowel = function(note) {
  if (!note) return false
  note = note.toLowerCase()
  return note.indexOf('towel') >= 0 || note.indexOf('serviette') >= 0
}

_.parseZipPostalCodes = function(text, return_error) {
  return_error || (return_error = false)
  if (!text) return []
  return _.reduce(text.split('\n'), (list, value, index) => {
    if (!_.isArray(list)) return list
    value = value.trim()
    if (return_error && (!value || value.length > 7)) {
      return trans('invalid_postal_code_on_line').replace(':value', value).replace(':line', index+1)
    }
    if (!!value) list.push(value)
    return list
  }, [])
}

_.validPostalCode = function(str) {
  if (!str) return false
  return !!str.match(/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i)
}

_.removeAccents = function(str) {
  if (!str) return str
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

// Same as helper is_sin_valid. Keep in sync.
// Should return true for 123 456 782
_.isSinValid = function(sin) {
    if (!sin) return false
    sin = (sin+'').replace(/\s+/g, '')
    if (sin.length != 9 || !_.isNumeric(sin)) return false
    sum = 0
    for (let i = 0; i < 8; i++) {
      if ([1, 3, 5, 7].indexOf(i) >= 0) {
        num = (2 * sin.substring(i, i+1))+''
        sum += 1 * num.substring(0, 1)
        if (num.length == 2) {
          sum += 1 * num.substring(1)
        }
      } else {
        sum += 1 * sin.substring(i, i+1)
      }
    }
    let control = Math.ceil(sum/10)*10 - sum
    if (control == 10) control = 0
    return sin.substring(8) == control
  }

_.printCreditCard = function(o) {
  if (!o || !o.card_last_four || !o.card_brand) return null
  return _.compact([
    o.card_brand.toUpperCase(),
    `XXXX XXXX XXXX ${o.card_last_four}`,
    !!o.card_exp_month && !!o.card_exp_year ? `exp ${o.card_exp_month}/${o.card_exp_year}` : null,
  ]).join(' ')
}

_.slugify = function(s) {
  if (!s) return s
  return _.snakeCase(s).replace(/_/g, '-')
}

_.permissionOptions = [{
  value: 'public',
  text: trans('page_permission_public'),
}, {
  value: 'client',
  text: trans('page_permission_client'),
}, {
  value: 'member',
  text: trans('page_permission_member'),
}, {
  value: 'admin',
  text: trans('page_permission_admin'),
}, {
  value: 'hidden',
  text: trans('page_permission_hidden'),
}]

_.getScheduledPaymentTypeLabel = function(type) {
  return trans(type == 'stripe_scheduled' ? 'credit_card_stripe' : (type == 'check' ? 'postdated_check' : (type == 'debit_scheduled' ? 'debit_stripe' : 'email_client')))
}

_.isStripePaymentCreditCard = function(p) {
  return p.type.indexOf('stripe') === 0 ||
    p.type.indexOf('ch_') === 0
}
_.isStripePaymentDebit = function(p) {
  return ['debit', 'debit_scheduled'].indexOf(p.type) >= 0
}
_.isStripePayment = function(p) {
  return _.isStripePaymentCreditCard(p) || _.isStripePaymentDebit(p)
}

_.bTableToString = function(value) {
  if (value === null || typeof value === 'undefined') {
    return ''
  } else if (value instanceof Object) {
    return Object.keys(value)
      .sort()
      .map(key => toString(value[key]))
      .join(' ')
  } else {
    return String(value)
  }
}

// NOTE: Same logic as App\Repositories\Frontend\LocationRepository::getHierarchy(). Keep in sync.
_.buildNestedLocationOptions = function(locations, disabledLocationIds, conflictingLocationIds, unavailableLocationIds) {
  let map = _.reduce(locations || [], (options, l) => {
    let label = l.name || '?'
    if (l.type == 'equipment' && l.sku) label += ` (${l.sku})`
    let option = {
      id: l.id,
      label: label,
      isDisabled: (disabledLocationIds || []).indexOf(l.id) >= 0,
      children: undefined,
      overlaps_location_id: l.overlaps_location_id || null,
      conflict: (conflictingLocationIds || []).indexOf(l.id) >= 0,
      unavailable: l.type === 'staff' && (unavailableLocationIds || []).indexOf(l.id) >= 0,
      order: l.order,
      type: l.type,
    }
    options[option.id] = option
    return options
  }, {})

  let all_children_ids = []
  _.each(map, (option, id) => {
    if (!!option.overlaps_location_id) {
      let parent = map[option.overlaps_location_id]
      if (!!parent) {
        let o = _.find(parent.children, {id: id})
        if (!o) {
          if (!parent.children) parent.children = []
          parent.children.push(option)
          all_children_ids.push(id)
        }
      }
    }
  })

  return _.sortBy(_.reduce(map, (options, option, id) => {
    if (all_children_ids.indexOf(id) >= 0) return options
    options.push(option)
    return options
  }, []), 'order')
}

// NOTE: Same logic as App\Repositories\Frontend\LocationRepository::getLocationOverlapMap(). Keep in sync.
_.getOverlappingLocationIds = function(locations, ids) {
  function walkUp(all_ids, node, nodes) {
    if (!!node.overlaps_location_id) {
      let parent = nodes[node.overlaps_location_id]
      if (!!parent) {
        if (all_ids.indexOf(parent.id) === -1) {
          all_ids.push(parent.id)
          all_ids = walkUp(all_ids, parent, nodes)
        }
      }
    }
    return all_ids
  }
  function walkDown(all_ids, node) {
    _.each(node.children || [], child => {
      if (all_ids.indexOf(child.id) === -1) {
        all_ids.push(child.id)
        all_ids = walkDown(all_ids, child)
      }
    })
    return all_ids
  }
  function mapNode(nodes, node) {
    if (!nodes[node.id]) nodes[node.id] = node
    _.each(node.children || [], n => {
      if (!nodes[n.id]) {
        nodes[n.id] = n
        nodes = mapNode(nodes, n)
      }
    })
    return nodes
  }
  let options = _.buildNestedLocationOptions(locations, [])
  let nodes = _.reduce(options, (nodes, node) => {
    return mapNode(nodes, node)
  }, {})
  return _.reduce(ids, (all_ids, id) => {
    let node = nodes[id]
    if (!!node && all_ids.indexOf(id) === -1) {
      all_ids.push(id)
      all_ids = walkUp(all_ids, node, nodes)
      all_ids = walkDown(all_ids, node)
    }
    return all_ids
  }, [])
}

// NOTE: Same logic as App\Repositories\Frontend\LocationRepository::getDescendants(). Keep in sync.
_.getDescendantLocationIds = function(locations, ids) {
  function walkDown(all_ids, node) {
    _.each(node.children || [], child => {
      if (all_ids.indexOf(child.id) === -1) {
        all_ids.push(child.id)
        all_ids = walkDown(all_ids, child)
      }
    })
    return all_ids
  }
  function mapNode(nodes, node) {
    if (!nodes[node.id]) nodes[node.id] = node
    _.each(node.children || [], n => {
      if (!nodes[n.id]) {
        nodes[n.id] = n
        nodes = mapNode(nodes, n)
      }
    })
    return nodes
  }
  let options = _.buildNestedLocationOptions(locations, [])
  let nodes = _.reduce(options, (nodes, node) => {
    return mapNode(nodes, node)
  }, {})
  return _.reduce(ids, (all_ids, id) => {
    let node = nodes[id]
    if (!!node && all_ids.indexOf(id) === -1) {
      all_ids.push(id)
      all_ids = walkDown(all_ids, node)
    }
    return all_ids
  }, [])
}

_.translateGenderEN = function(gender) {
  if (!gender) return gender
    switch (gender.toLowerCase()) {
      case 'masculin':
      case 'homme':
      case 'garçon':
      case 'male':
      case 'boy':
        return 'Male'
      case 'féminin':
      case 'femme':
      case 'fille':
      case 'female':
      case 'girl':
        return 'Female'
      case 'transmasculin':
      case 'transmasculine':
        return 'Transmasculine'
      case 'transféminin':
      case 'transfeminine':
        return 'Transfeminine'
      case 'non binaire':
      case 'non binary':
        return 'Non binary'
      case 'non spécifié':
      case 'not specified':
        return 'Not specified'
      case 'préfère ne pas dire':
      case 'prefer not to say':
        return 'Prefer not to say'
      case 'bispirituel(le)':
      case 'two spirit':
        return 'Two spirit'
      case 'other':
      case 'autre':
        return 'Other'
    }
    return gender
}
_.translateGenderFR = function(gender) {
  if (!gender) return gender
  switch (gender.toLowerCase()) {
    case 'masculin':
    case 'homme':
    case 'garçon':
    case 'male':
    case 'boy':
      return 'Masculin'
    case 'féminin':
    case 'femme':
    case 'fille':
    case 'female':
    case 'girl':
      return 'Féminin'
    case 'transmasculin':
    case 'transmasculine':
      return 'Transmasculin'
    case 'transféminin':
    case 'transfeminine':
      return 'Transféminin'
    case 'non binaire':
    case 'non binary':
      return 'Non binaire'
    case 'non spécifié':
    case 'not specified':
      return 'Non spécifié'
    case 'préfère ne pas dire':
    case 'prefer not to say':
      return 'Préfère ne pas dire'
    case 'bispirituel(le)':
    case 'two spirit':
      return 'Bispirituel(le)'
    case 'other':
    case 'autre':
      return 'Autre'
  }
  return gender
}

_.isFranchisor = function(organization) {
  return organization.partner == 'Bougeotte et Placotine' && organization.id == 3848
}
_.isFranchisee = function(organization) {
  return organization.partner == 'Bougeotte et Placotine' && organization.id != 3848
}
_.isFranchiseeOrFranchisor = function(organization) {
  return _.isFranchisee(organization) || _.isFranchisor(organization)
}

_.getUserPermissions = function(organization) {
  return _.compact([
    'owner',
    'admin',
    'attendant',
    'communication_agent',
    'staff',
    'staff_no_messaging',
    'guest'
  ])
}

_.getUserCanPermissions = function(organization) {
  return _.compact([
    organization.has_bookings ? 'can_access_bookings' : null,
    organization.has_bookings ? 'can_own_bookings' : null,
    'can_access_users',
    'can_unlock',
    'can_access_gift_cards',
    'can_create_contracts',
    'can_manage_tags',
    'can_correct_invoices',
    'can_apply_coupons',
    'can_refund',
    organization.allows_interac ? 'can_settle_interac' : null,
    'can_connect_as_client',
    'can_access_client_ci',
    'can_merge_clients',
    'can_edit_microsite',
    'can_view_admin_questions',
    'can_modify_admin_questions',
    'can_view_payments_and_sales_reports_of_others',
    'can_modify_staff_availabilities',
    'can_edit_other_staff_availabilities',
    'can_edit_forms'
  ])
}

_.groupThreadMessages = function(twilio_messages, new_message) {
  let groupedMessages = []
  let messages = []
  let last = null
  let message = null
  let when = null
  for (let i = 0; i < twilio_messages.length; i++) {
    message = twilio_messages[i]
    let m = {
      id: message.id,
      body: _.urlify(message.body, '_blank'),
      source: message.type == 'inbound' ? 'yours' : 'mine',
      date_sent: message.date_sent,
      error: message.status == 'error' && !!message.error_message ? message.error_message : null,
    }
    if (!when && (!last || Math.abs(moment(m.date_sent).diff(last.date_sent, 'minute')) > 30)) {
      if (!!m.date_sent) when = moment(message.date_sent).fromNow()
    }
    if (!last || last.type == message.type) {
      messages.push(m)
    }
    else if (!!last && last.type != message.type) {
      groupedMessages.push({
        source: messages[0].source,
        messages: messages,
        when: when,
      })
      when = null
      messages = [m]
    }
    last = message
  }
  if (messages.length > 0) {
    groupedMessages.push({
      source: messages[0].source,
      messages: messages,
      when: when,
    })
  }
  if (!!new_message) {
    groupedMessages.push({
      source: 'mine',
      messages: [{
        id: -1,
        body: new_message,
        source: 'mine',
        date_sent: moment().toISOString(),
        error: null,
      }],
      when: null
    })
  }
  return groupedMessages
}

_.getHtmlWithAnchor = function(html) {
  if (!html) return html
  const regex = /^(<h[1-9][^>]*>)(.*?)(<\/h[1-9]>)/i
  const matches = html.match(regex)
  if (!matches || matches.length < 4) return html
  const slug = _.slugify(_.stripHtml(matches[2].trim()))
  if (!slug) return html
  const anchor = `<a id="${slug}" href="#${slug}" class="section-anchor text-branded">#&nbsp;</a>`
  return html.replace(matches[0], `${matches[1]}${anchor}${matches[2]}${matches[3]}`)
}

_.getHtmlWithAnchorPreview = function(html) {
  if (!html) return null
  const regex = /^(<h[1-9][^>]*>)(.*?)(<\/h[1-9]>)/i
  const matches = html.match(regex)
  if (!matches || matches.length < 4) return null
  const slug = _.slugify(_.stripHtml(matches[2].trim()))
  if (!slug) return null
  const anchor = `<a href="#${slug}" onclick="event.preventDefault()" class="section-anchor">#&nbsp;</a>`
  return `<strong class="text-dark">${anchor}${matches[2]}</strong>`
}

;(function(){
    const GSM7_DEFAULT = [
        '@','£','$','¥','è','é','ù','ì','ò','Ç','\n','Ø','ø','\r','Å','å',
        'Δ','_','Φ','Γ','Λ','Ω','Π','Ψ','Σ','Θ','Ξ','\u00A0','Æ','æ','É',
        ' ','!','"','#','¤','%','&',"'",'(',')','*','+',',','-','.','/',
        '0','1','2','3','4','5','6','7','8','9',':',';','<','=','>','?',
        '¡',
        'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q',
        'R','S','T','U','V','W','X','Y','Z','Ä','Ö','Ñ','Ü','§','¿',
        'a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q',
        'r','s','t','u','v','w','x','y','z','ä','ö','ñ','ü','à'
    ]
    const GSM7_EXTENDED = ['^','{','}','\\','[','~',']','|','€']
    const GSM7_EXTRA_FRENCH = ['â', 'ê', 'î', 'ô', 'û']


    const _defaultSet = new Set([...GSM7_DEFAULT, ...GSM7_EXTRA_FRENCH])
    const _extSet     = new Set(GSM7_EXTENDED)

    _.normalizeSmartPunctuation = function(str) {
        return str
            .replace(/[\u2018\u2019\u201A\u201B]/g, "'")
            .replace(/[\u201C\u201D\u201E\u201F]/g, '"')
            .replace(/\u2013|\u2014/g, '-')
            .replace(/\u2026/g, '...')
            .replace(/\u00A0/g, ' ')
    }

    _.isGsm7 = function(html) {
        const plain = _.normalizeSmartPunctuation(_.ckeditorHtmlToText(html))
        for (let ch of plain) {
            if (_defaultSet.has(ch) || _extSet.has(ch)) continue
            return false
        }
        return true
    }
})()

;(function(){
    const vsRe = /\p{Variation_Selector}/gu;
    const zwjRe = /\u200D/g;
    const pictographicRe = /\p{Extended_Pictographic}/u;

    _.containsEmoji = function(html) {

        let txt = _.ckeditorHtmlToText(html);

        txt = txt.replace(vsRe, '').replace(zwjRe, '');

        return pictographicRe.test(txt);
    }
})()
